export const WalletCurrency = [
  {
    name: "Ethereum Mainnet",
    chain_id: "1",
    currency: "ETH",
  },
  {
    name: "Expanse Network",
    chain_id: "2",
    currency: "EXP",
  },
  {
    name: "Ropsten",
    chain_id: "3",
    currency: "ETH",
  },
  {
    name: "Rinkeby",
    chain_id: "4",
    currency: "ETH",
  },
  {
    name: "Goerli",
    chain_id: "5",
    currency: "ETH",
  },
  {
    name: "ThaiChain",
    chain_id: "7",
    currency: "TCH",
  },
  {
    name: "Ubiq",
    chain_id: "8",
    currency: "UBQ",
  },
  {
    name: "OP Mainnet",
    chain_id: "10",
    currency: "ETH",
  },
  {
    name: "Metadium Mainnet",
    chain_id: "11",
    currency: "META",
  },
  {
    name: "Metadium Testnet",
    chain_id: "12",
    currency: "KAL",
  },
  {
    name: "Diode Testnet Staging",
    chain_id: "13",
    currency: "sDIODE",
  },
  {
    name: "Flare Mainnet",
    chain_id: "14",
    currency: "FLR",
  },
  {
    name: "Diode Prenet",
    chain_id: "15",
    currency: "DIODE",
  },
  {
    name: "Songbird Testnet Coston",
    chain_id: "16",
    currency: "CFLR",
  },
  {
    name: "ThaiChain 2.0 ThaiFi",
    chain_id: "17",
    currency: "TFI",
  },
  {
    name: "ThunderCore Testnet",
    chain_id: "18",
    currency: "TST",
  },
  {
    name: "Songbird Canary-Network",
    chain_id: "19",
    currency: "SGB",
  },
  {
    name: "Elastos Smart Chain",
    chain_id: "20",
    currency: "ELA",
  },
  {
    name: "Elastos Smart Chain Testnet",
    chain_id: "21",
    currency: "tELA",
  },
  {
    name: "KardiaChain Mainnet",
    chain_id: "24",
    currency: "KAI",
  },
  {
    name: "Cronos Mainnet",
    chain_id: "25",
    currency: "CRO",
  },
  {
    name: "Genesis L1 testnet",
    chain_id: "26",
    currency: "L1test",
  },
  {
    name: "ShibaChain",
    chain_id: "27",
    currency: "SHIB",
  },
  {
    name: "Boba Network Rinkeby Testnet",
    chain_id: "28",
    currency: "ETH",
  },
  {
    name: "Genesis L1",
    chain_id: "29",
    currency: "L1",
  },
  {
    name: "Rootstock Mainnet",
    chain_id: "30",
    currency: "RBTC",
  },
  {
    name: "Rootstock Testnet",
    chain_id: "31",
    currency: "tRBTC",
  },
  {
    name: "GoodData Testnet",
    chain_id: "32",
    currency: "GooD",
  },
  {
    name: "GoodData Mainnet",
    chain_id: "33",
    currency: "GooD",
  },
  {
    name: "SecureChain Mainnet",
    chain_id: "34",
    currency: "SCAI",
  },
  {
    name: "TBWG Chain",
    chain_id: "35",
    currency: "TBG",
  },
  {
    name: "Dxchain Mainnet",
    chain_id: "36",
    currency: "DX",
  },
  {
    name: "Xpla Mainnet",
    chain_id: "37",
    currency: "XPLA",
  },
  {
    name: "Valorbit",
    chain_id: "38",
    currency: "VAL",
  },
  {
    name: "U2U Solaris Mainnet",
    chain_id: "39",
    currency: "U2U",
  },
  {
    name: "Telos EVM Mainnet",
    chain_id: "40",
    currency: "TLOS",
  },
  {
    name: "Telos EVM Testnet",
    chain_id: "41",
    currency: "TLOS",
  },
  {
    name: "LUKSO Mainnet",
    chain_id: "42",
    currency: "LYX",
  },
  {
    name: "Darwinia Pangolin Testnet",
    chain_id: "43",
    currency: "PRING",
  },
  {
    name: "Crab Network",
    chain_id: "44",
    currency: "CRAB",
  },
  {
    name: "Darwinia Pangoro Testnet",
    chain_id: "45",
    currency: "ORING",
  },
  {
    name: "Darwinia Network",
    chain_id: "46",
    currency: "RING",
  },
  {
    name: "Acria IntelliChain",
    chain_id: "47",
    currency: "ACRIA",
  },
  {
    name: "Ennothem Mainnet Proterozoic",
    chain_id: "48",
    currency: "ETMP",
  },
  {
    name: "Ennothem Testnet Pioneer",
    chain_id: "49",
    currency: "ETMP",
  },
  {
    name: "XDC Network",
    chain_id: "50",
    currency: "XDC",
  },
  {
    name: "XDC Apothem Network",
    chain_id: "51",
    currency: "TXDC",
  },
  {
    name: "CoinEx Smart Chain Mainnet",
    chain_id: "52",
    currency: "cet",
  },
  {
    name: "CoinEx Smart Chain Testnet",
    chain_id: "53",
    currency: "cett",
  },
  {
    name: "Openpiece Mainnet",
    chain_id: "54",
    currency: "BELLY",
  },
  {
    name: "Zyx Mainnet",
    chain_id: "55",
    currency: "ZYX",
  },
  {
    name: "BNB Smart Chain Mainnet",
    chain_id: "56",
    currency: "BNB",
  },
  {
    name: "Syscoin Mainnet",
    chain_id: "57",
    currency: "SYS",
  },
  {
    name: "Ontology Mainnet",
    chain_id: "58",
    currency: "ONG",
  },
  {
    name: "EOS EVM Legacy",
    chain_id: "59",
    currency: "EOS",
  },
  {
    name: "GoChain",
    chain_id: "60",
    currency: "GO",
  },
  {
    name: "Ethereum Classic",
    chain_id: "61",
    currency: "ETC",
  },
  {
    name: "Mordor Testnet",
    chain_id: "63",
    currency: "METC",
  },
  {
    name: "Ellaism",
    chain_id: "64",
    currency: "ELLA",
  },
  {
    name: "OKExChain Testnet",
    chain_id: "65",
    currency: "OKT",
  },
  {
    name: "OKXChain Mainnet",
    chain_id: "66",
    currency: "OKT",
  },
  {
    name: "DBChain Testnet",
    chain_id: "67",
    currency: "DBM",
  },
  {
    name: "SoterOne Mainnet",
    chain_id: "68",
    currency: "SOTER",
  },
  {
    name: "Optimism Kovan",
    chain_id: "69",
    currency: "ETH",
  },
  {
    name: "Hoo Smart Chain",
    chain_id: "70",
    currency: "HOO",
  },
  {
    name: "Conflux eSpace (Testnet)",
    chain_id: "71",
    currency: "CFX",
  },
  {
    name: "DxChain Testnet",
    chain_id: "72",
    currency: "DX",
  },
  {
    name: "FNCY",
    chain_id: "73",
    currency: "FNCY",
  },
  {
    name: "IDChain Mainnet",
    chain_id: "74",
    currency: "EIDI",
  },
  {
    name: "Decimal Smart Chain Mainnet",
    chain_id: "75",
    currency: "DEL",
  },
  {
    name: "Mix",
    chain_id: "76",
    currency: "MIX",
  },
  {
    name: "POA Network Sokol",
    chain_id: "77",
    currency: "SPOA",
  },
  {
    name: "PrimusChain mainnet",
    chain_id: "78",
    currency: "PETH",
  },
  {
    name: "Zenith Mainnet",
    chain_id: "79",
    currency: "ZENITH",
  },
  {
    name: "GeneChain",
    chain_id: "80",
    currency: "RNA",
  },
  {
    name: "Japan Open Chain Mainnet",
    chain_id: "81",
    currency: "JOC",
  },
  {
    name: "Meter Mainnet",
    chain_id: "82",
    currency: "MTR",
  },
  {
    name: "Meter Testnet",
    chain_id: "83",
    currency: "MTR",
  },
  {
    name: "Linqto Devnet",
    chain_id: "84",
    currency: "XRP",
  },
  {
    name: "GateChain Testnet",
    chain_id: "85",
    currency: "GT",
  },
  {
    name: "GateChain Mainnet",
    chain_id: "86",
    currency: "GT",
  },
  {
    name: "Nova Network",
    chain_id: "87",
    currency: "SNT",
  },
  {
    name: "Viction",
    chain_id: "88",
    currency: "VIC",
  },
  {
    name: "Viction Testnet",
    chain_id: "89",
    currency: "VIC",
  },
  {
    name: "Garizon Stage0",
    chain_id: "90",
    currency: "GAR",
  },
  {
    name: "Garizon Stage1",
    chain_id: "91",
    currency: "GAR",
  },
  {
    name: "Garizon Stage2",
    chain_id: "92",
    currency: "GAR",
  },
  {
    name: "Garizon Stage3",
    chain_id: "93",
    currency: "GAR",
  },
  {
    name: "SwissDLT",
    chain_id: "94",
    currency: "BCTS",
  },
  {
    name: "CamDL Mainnet",
    chain_id: "95",
    currency: "CADL",
  },
  {
    name: "Bitkub Chain",
    chain_id: "96",
    currency: "KUB",
  },
  {
    name: "BNB Smart Chain Testnet",
    chain_id: "97",
    currency: "tBNB",
  },
  {
    name: "Six Protocol",
    chain_id: "98",
    currency: "SIX",
  },
  {
    name: "POA Network Core",
    chain_id: "99",
    currency: "POA",
  },
  {
    name: "Gnosis",
    chain_id: "100",
    currency: "XDAI",
  },
  {
    name: "EtherInc",
    chain_id: "101",
    currency: "ETI",
  },
  {
    name: "Web3Games Testnet",
    chain_id: "102",
    currency: "W3G",
  },
  {
    name: "WorldLand Mainnet",
    chain_id: "103",
    currency: "WLC",
  },
  {
    name: "Kaiba Lightning Chain Testnet",
    chain_id: "104",
    currency: "tKAIBA",
  },
  {
    name: "Web3Games Devnet",
    chain_id: "105",
    currency: "W3G",
  },
  {
    name: "Velas EVM Mainnet",
    chain_id: "106",
    currency: "VLX",
  },
  {
    name: "Nebula Testnet",
    chain_id: "107",
    currency: "NBX",
  },
  {
    name: "ThunderCore Mainnet",
    chain_id: "108",
    currency: "TT",
  },
  {
    name: "Shibarium",
    chain_id: "109",
    currency: "BONE",
  },
  {
    name: "Proton Testnet",
    chain_id: "110",
    currency: "XPR",
  },
  {
    name: "EtherLite Chain",
    chain_id: "111",
    currency: "ETL",
  },
  {
    name: "Coinbit Mainnet",
    chain_id: "112",
    currency: "GIDR",
  },
  {
    name: "Dehvo",
    chain_id: "113",
    currency: "Deh",
  },
  {
    name: "Flare Testnet Coston2",
    chain_id: "114",
    currency: "C2FLR",
  },
  {
    name: "Uptick Mainnet",
    chain_id: "117",
    currency: "UPTICK",
  },
  {
    name: "Arcology Testnet",
    chain_id: "118",
    currency: "Acol",
  },
  {
    name: "ENULS Mainnet",
    chain_id: "119",
    currency: "NULS",
  },
  {
    name: "ENULS Testnet",
    chain_id: "120",
    currency: "NULS",
  },
  {
    name: "Realchain Mainnet",
    chain_id: "121",
    currency: "REAL",
  },
  {
    name: "Fuse Mainnet",
    chain_id: "122",
    currency: "FUSE",
  },
  {
    name: "Fuse Sparknet",
    chain_id: "123",
    currency: "SPARK",
  },
  {
    name: "Decentralized Web Mainnet",
    chain_id: "124",
    currency: "DWU",
  },
  {
    name: "OYchain Testnet",
    chain_id: "125",
    currency: "OY",
  },
  {
    name: "OYchain Mainnet",
    chain_id: "126",
    currency: "OY",
  },
  {
    name: "Huobi ECO Chain Mainnet",
    chain_id: "128",
    currency: "HT",
  },
  {
    name: "Innovator Chain",
    chain_id: "129",
    currency: "INOV8",
  },
  {
    name: "Engram Testnet",
    chain_id: "131",
    currency: "tGRAM",
  },
  {
    name: "Namefi Chain Mainnet",
    chain_id: "132",
    currency: "NFIC",
  },
  {
    name: "iExec Sidechain",
    chain_id: "134",
    currency: "xRLC",
  },
  {
    name: "Alyx Chain Testnet",
    chain_id: "135",
    currency: "ALYX",
  },
  {
    name: "Deamchain Mainnet",
    chain_id: "136",
    currency: "DEAM",
  },
  {
    name: "Polygon Mainnet",
    chain_id: "137",
    currency: "MATIC",
  },
  {
    name: "Defi Oracle Meta Mainnet",
    chain_id: "138",
    currency: "ETH",
  },
  {
    name: "WoopChain Mainnet",
    chain_id: "139",
    currency: "WOOC",
  },
  {
    name: "Eternal Mainnet",
    chain_id: "140",
    currency: "Eter",
  },
  {
    name: "Openpiece Testnet",
    chain_id: "141",
    currency: "BELLY",
  },
  {
    name: "DAX CHAIN",
    chain_id: "142",
    currency: "DAX",
  },
  {
    name: "PHI Network v2",
    chain_id: "144",
    currency: "\u03a6",
  },
  {
    name: "SoraAI Testnet",
    chain_id: "145",
    currency: "SETH",
  },
  {
    name: "Flag Mainnet",
    chain_id: "147",
    currency: "FLAG",
  },
  {
    name: "ShimmerEVM",
    chain_id: "148",
    currency: "SMR",
  },
  {
    name: "Six Protocol Testnet",
    chain_id: "150",
    currency: "tSIX",
  },
  {
    name: "Redbelly Network Testnet",
    chain_id: "153",
    currency: "RBNT",
  },
  {
    name: "Tenet Testnet",
    chain_id: "155",
    currency: "TENET",
  },
  {
    name: "OEBlock Testnet",
    chain_id: "156",
    currency: "OEB",
  },
  {
    name: "Puppynet Shibarium",
    chain_id: "157",
    currency: "BONE",
  },
  {
    name: "Roburna Mainnet",
    chain_id: "158",
    currency: "RBA",
  },
  {
    name: "Roburna Testnet",
    chain_id: "159",
    currency: "RBAT",
  },
  {
    name: "Armonia Eva Chain Mainnet",
    chain_id: "160",
    currency: "AMAX",
  },
  {
    name: "Armonia Eva Chain Testnet",
    chain_id: "161",
    currency: "AMAX",
  },
  {
    name: "Lightstreams Testnet",
    chain_id: "162",
    currency: "PHT",
  },
  {
    name: "Lightstreams Mainnet",
    chain_id: "163",
    currency: "PHT",
  },
  {
    name: "Omni Testnet",
    chain_id: "164",
    currency: "OMNI",
  },
  {
    name: "Atoshi Testnet",
    chain_id: "167",
    currency: "ATOS",
  },
  {
    name: "AIOZ Network",
    chain_id: "168",
    currency: "AIOZ",
  },
  {
    name: "Manta Pacific Mainnet",
    chain_id: "169",
    currency: "ETH",
  },
  {
    name: "HOO Smart Chain Testnet",
    chain_id: "170",
    currency: "HOO",
  },
  {
    name: "Latam-Blockchain Resil Testnet",
    chain_id: "172",
    currency: "usd",
  },
  {
    name: "DC Mainnet",
    chain_id: "176",
    currency: "DCT",
  },
  {
    name: "ABEY Testnet",
    chain_id: "178",
    currency: "tABEY",
  },
  {
    name: "ABEY Mainnet",
    chain_id: "179",
    currency: "ABEY",
  },
  {
    name: "AME Chain Mainnet",
    chain_id: "180",
    currency: "AME",
  },
  {
    name: "Waterfall Network",
    chain_id: "181",
    currency: "WATER",
  },
  {
    name: "Dojima Testnet",
    chain_id: "184",
    currency: "DOJ",
  },
  {
    name: "Mint Mainnet",
    chain_id: "185",
    currency: "ETH",
  },
  {
    name: "Seele Mainnet",
    chain_id: "186",
    currency: "Seele",
  },
  {
    name: "Dojima",
    chain_id: "187",
    currency: "DOJ",
  },
  {
    name: "BMC Mainnet",
    chain_id: "188",
    currency: "BTM",
  },
  {
    name: "BMC Testnet",
    chain_id: "189",
    currency: "BTM",
  },
  {
    name: "CMDAO BBQ Chain",
    chain_id: "190",
    currency: "CMD",
  },
  {
    name: "FileFileGo",
    chain_id: "191",
    currency: "FFG",
  },
  {
    name: "Crypto Emergency",
    chain_id: "193",
    currency: "CEM",
  },
  {
    name: "X Layer Testnet",
    chain_id: "195",
    currency: "OKB",
  },
  {
    name: "X Layer Mainnet",
    chain_id: "196",
    currency: "OKB",
  },
  {
    name: "Neutrinos TestNet",
    chain_id: "197",
    currency: "NEUTR",
  },
  {
    name: "Bitchain Mainnet",
    chain_id: "198",
    currency: "BTC",
  },
  {
    name: "BitTorrent Chain Mainnet",
    chain_id: "199",
    currency: "BTT",
  },
  {
    name: "Arbitrum on xDai",
    chain_id: "200",
    currency: "xDAI",
  },
  {
    name: "MOAC testnet",
    chain_id: "201",
    currency: "mc",
  },
  {
    name: "Edgeless Testnet",
    chain_id: "202",
    currency: "EwEth",
  },
  {
    name: "opBNB Mainnet",
    chain_id: "204",
    currency: "BNB",
  },
  {
    name: "VinuChain Testnet",
    chain_id: "206",
    currency: "VC",
  },
  {
    name: "VinuChain Network",
    chain_id: "207",
    currency: "VC",
  },
  {
    name: "Structx Mainnet",
    chain_id: "208",
    currency: "utx",
  },
  {
    name: "Bitnet",
    chain_id: "210",
    currency: "BTN",
  },
  {
    name: "Freight Trust Network",
    chain_id: "211",
    currency: "0xF",
  },
  {
    name: "MAPO Makalu",
    chain_id: "212",
    currency: "MAPO",
  },
  {
    name: "B2 Hub Mainnet",
    chain_id: "213",
    currency: "B2",
  },
  {
    name: "Shinarium Mainnet",
    chain_id: "214",
    currency: "SHI",
  },
  {
    name: "SiriusNet V2",
    chain_id: "217",
    currency: "MCD",
  },
  {
    name: "SoterOne Mainnet old",
    chain_id: "218",
    currency: "SOTER",
  },
  {
    name: "Scalind Testnet",
    chain_id: "220",
    currency: "ETH",
  },
  {
    name: "BlockEx Mainnet",
    chain_id: "221",
    currency: "XBE",
  },
  {
    name: "Permission",
    chain_id: "222",
    currency: "ASK",
  },
  {
    name: "B2 Mainnet",
    chain_id: "223",
    currency: "BTC",
  },
  {
    name: "Viridis Testnet",
    chain_id: "224",
    currency: "VRD",
  },
  {
    name: "LACHAIN Mainnet",
    chain_id: "225",
    currency: "LA",
  },
  {
    name: "LACHAIN Testnet",
    chain_id: "226",
    currency: "TLA",
  },
  {
    name: "Mind Network Mainnet",
    chain_id: "228",
    currency: "FHE",
  },
  {
    name: "SwapDEX",
    chain_id: "230",
    currency: "SDX",
  },
  {
    name: "ProtoJumbo Testnet",
    chain_id: "234",
    currency: "JNFTC",
  },
  {
    name: "Deamchain Testnet",
    chain_id: "236",
    currency: "DEAM",
  },
  {
    name: "Blast Mainnet",
    chain_id: "238",
    currency: "ETH",
  },
  {
    name: "Plinga Mainnet",
    chain_id: "242",
    currency: "PLINGA",
  },
  {
    name: "Energy Web Chain",
    chain_id: "246",
    currency: "EWT",
  },
  {
    name: "Oasys Mainnet",
    chain_id: "248",
    currency: "OAS",
  },
  {
    name: "Fantom Opera",
    chain_id: "250",
    currency: "FTM",
  },
  {
    name: "Fraxtal",
    chain_id: "252",
    currency: "frxETH",
  },
  {
    name: "Swan Chain Mainnet",
    chain_id: "254",
    currency: "sETH",
  },
  {
    name: "Kroma",
    chain_id: "255",
    currency: "ETH",
  },
  {
    name: "Huobi ECO Chain Testnet",
    chain_id: "256",
    currency: "htt",
  },
  {
    name: "Neonlink Mainnet",
    chain_id: "259",
    currency: "NEON",
  },
  {
    name: "Guru Network Testnet",
    chain_id: "261",
    currency: "tGURU",
  },
  {
    name: "SUR Blockchain Network",
    chain_id: "262",
    currency: "SRN",
  },
  {
    name: "Neura Testnet",
    chain_id: "267",
    currency: "ANKR",
  },
  {
    name: "High Performance Blockchain",
    chain_id: "269",
    currency: "HPB",
  },
  {
    name: "EgonCoin Mainnet",
    chain_id: "271",
    currency: "EGON",
  },
  {
    name: "LaChain",
    chain_id: "274",
    currency: "LAC",
  },
  {
    name: "xFair.AI Mainnet",
    chain_id: "278",
    currency: "FAI",
  },
  {
    name: "BPX Blockchain",
    chain_id: "279",
    currency: "BPX",
  },
  {
    name: "zkSync Era Goerli Testnet (deprecated)",
    chain_id: "280",
    currency: "ETH",
  },
  {
    name: "Cronos zkEVM Testnet",
    chain_id: "282",
    currency: "zkTCRO",
  },
  {
    name: "Boba Network",
    chain_id: "288",
    currency: "ETH",
  },
  {
    name: "Orderly Mainnet",
    chain_id: "291",
    currency: "ETH",
  },
  {
    name: "Hedera Mainnet",
    chain_id: "295",
    currency: "HBAR",
  },
  {
    name: "Hedera Testnet",
    chain_id: "296",
    currency: "HBAR",
  },
  {
    name: "Hedera Previewnet",
    chain_id: "297",
    currency: "HBAR",
  },
  {
    name: "zkSync Sepolia Testnet",
    chain_id: "300",
    currency: "ETH",
  },
  {
    name: "Bobaopera",
    chain_id: "301",
    currency: "BOBA",
  },
  {
    name: "zkCandy Sepolia Testnet",
    chain_id: "302",
    currency: "ETH",
  },
  {
    name: "Neurochain Testnet",
    chain_id: "303",
    currency: "tNCN",
  },
  {
    name: "ZKSats Mainnet",
    chain_id: "305",
    currency: "BTC",
  },
  {
    name: "Lovely Network Testnet",
    chain_id: "307",
    currency: "LOVELY",
  },
  {
    name: "Furtheon",
    chain_id: "308",
    currency: "FTH",
  },
  {
    name: "Wyzth Testnet",
    chain_id: "309",
    currency: "WYZ",
  },
  {
    name: "Omax Mainnet",
    chain_id: "311",
    currency: "OMAX",
  },
  {
    name: "Neurochain Mainnet",
    chain_id: "313",
    currency: "NCN",
  },
  {
    name: "Filecoin - Mainnet",
    chain_id: "314",
    currency: "FIL",
  },
  {
    name: "KCC Mainnet",
    chain_id: "321",
    currency: "KCS",
  },
  {
    name: "KCC Testnet",
    chain_id: "322",
    currency: "tKCS",
  },
  {
    name: "Cosvm Mainnet",
    chain_id: "323",
    currency: "CVM",
  },
  {
    name: "zkSync Mainnet",
    chain_id: "324",
    currency: "ETH",
  },
  {
    name: "Web3Q Mainnet",
    chain_id: "333",
    currency: "W3Q",
  },
  {
    name: "DFK Chain Test",
    chain_id: "335",
    currency: "JEWEL",
  },
  {
    name: "Shiden",
    chain_id: "336",
    currency: "SDN",
  },
  {
    name: "Cronos Testnet",
    chain_id: "338",
    currency: "TCRO",
  },
  {
    name: "TSC Mainnet",
    chain_id: "345",
    currency: "TAS",
  },
  {
    name: "Theta Mainnet",
    chain_id: "361",
    currency: "TFUEL",
  },
  {
    name: "Theta Sapphire Testnet",
    chain_id: "363",
    currency: "TFUEL",
  },
  {
    name: "Theta Amber Testnet",
    chain_id: "364",
    currency: "TFUEL",
  },
  {
    name: "Theta Testnet",
    chain_id: "365",
    currency: "TFUEL",
  },
  {
    name: "PulseChain",
    chain_id: "369",
    currency: "PLS",
  },
  {
    name: "Consta Testnet",
    chain_id: "371",
    currency: "tCNT",
  },
  {
    name: "ZKAmoeba Testnet",
    chain_id: "380",
    currency: "FIL",
  },
  {
    name: "ZKAmoeba Mainnet",
    chain_id: "381",
    currency: "FIL",
  },
  {
    name: "Lisinski",
    chain_id: "385",
    currency: "LISINS",
  },
  {
    name: "CamDL Testnet",
    chain_id: "395",
    currency: "CADL",
  },
  {
    name: "Nativ3 Mainnet",
    chain_id: "399",
    currency: "USNT",
  },
  {
    name: "HyperonChain TestNet",
    chain_id: "400",
    currency: "HPN",
  },
  {
    name: "Ozone Chain Testnet",
    chain_id: "401",
    currency: "OZO",
  },
  {
    name: "Syndr L3",
    chain_id: "404",
    currency: "ETH",
  },
  {
    name: "Pepe Chain Mainnet",
    chain_id: "411",
    currency: "PEPE",
  },
  {
    name: "SX Network Mainnet",
    chain_id: "416",
    currency: "SX",
  },
  {
    name: "LaTestnet",
    chain_id: "418",
    currency: "TLA",
  },
  {
    name: "Optimism Goerli Testnet",
    chain_id: "420",
    currency: "ETH",
  },
  {
    name: "Viridis Mainnet",
    chain_id: "422",
    currency: "VRD",
  },
  {
    name: "PGN (Public Goods Network)",
    chain_id: "424",
    currency: "ETH",
  },
  {
    name: "Zeeth Chain",
    chain_id: "427",
    currency: "ZTH",
  },
  {
    name: "Geso Verse",
    chain_id: "428",
    currency: "OAS",
  },
  {
    name: "Boyaa Mainnet",
    chain_id: "434",
    currency: "BYC",
  },
  {
    name: "Ten Testnet",
    chain_id: "443",
    currency: "ETH",
  },
  {
    name: "Synapse Chain Testnet",
    chain_id: "444",
    currency: "ETH",
  },
  {
    name: "ARZIO Chain",
    chain_id: "456",
    currency: "AZO",
  },
  {
    name: "Areon Network Testnet",
    chain_id: "462",
    currency: "TAREA",
  },
  {
    name: "Areon Network Mainnet",
    chain_id: "463",
    currency: "AREA",
  },
  {
    name: "Camino C-Chain",
    chain_id: "500",
    currency: "CAM",
  },
  {
    name: "Columbus Test Network",
    chain_id: "501",
    currency: "CAM",
  },
  {
    name: "Syndicate Chain",
    chain_id: "510",
    currency: "ETH",
  },
  {
    name: "Double-A Chain Mainnet",
    chain_id: "512",
    currency: "AAC",
  },
  {
    name: "Double-A Chain Testnet",
    chain_id: "513",
    currency: "AAC",
  },
  {
    name: "Gear Zero Network Mainnet",
    chain_id: "516",
    currency: "GZN",
  },
  {
    name: "XT Smart Chain Mainnet",
    chain_id: "520",
    currency: "XT",
  },
  {
    name: "Firechain Mainnet",
    chain_id: "529",
    currency: "FIRE",
  },
  {
    name: "F(x)Core Mainnet Network",
    chain_id: "530",
    currency: "FX",
  },
  {
    name: "Candle",
    chain_id: "534",
    currency: "CNDL",
  },
  {
    name: "OpTrust Mainnet",
    chain_id: "537",
    currency: "BNB",
  },
  {
    name: "PAWCHAIN Testnet",
    chain_id: "542",
    currency: "PAW",
  },
  {
    name: "Testnet",
    chain_id: "545",
    currency: "FLOW",
  },
  {
    name: "Vela1 Chain Mainnet",
    chain_id: "555",
    currency: "CLASS",
  },
  {
    name: "Tao Network",
    chain_id: "558",
    currency: "TAO",
  },
  {
    name: "Dogechain Testnet",
    chain_id: "568",
    currency: "DOGE",
  },
  {
    name: "Rollux Mainnet",
    chain_id: "570",
    currency: "SYS",
  },
  {
    name: "MetaChain Mainnet",
    chain_id: "571",
    currency: "MTC",
  },
  {
    name: "Filenova Mainnet",
    chain_id: "579",
    currency: "FIL",
  },
  {
    name: "Metis Stardust Testnet",
    chain_id: "588",
    currency: "METIS",
  },
  {
    name: "Astar",
    chain_id: "592",
    currency: "ASTR",
  },
  {
    name: "Acala Mandala Testnet TC9",
    chain_id: "595",
    currency: "mACA",
  },
  {
    name: "Karura Network Testnet",
    chain_id: "596",
    currency: "KAR",
  },
  {
    name: "Acala Network Testnet",
    chain_id: "597",
    currency: "ACA",
  },
  {
    name: "Metis Goerli Testnet",
    chain_id: "599",
    currency: "METIS",
  },
  {
    name: "Vine Testnet",
    chain_id: "601",
    currency: "VNE",
  },
  {
    name: "Darwin Devnet",
    chain_id: "610",
    currency: "DNA",
  },
  {
    name: "EIOB Mainnet",
    chain_id: "612",
    currency: "EIOB",
  },
  {
    name: "Graphlinq Blockchain Mainnet",
    chain_id: "614",
    currency: "GLQ",
  },
  {
    name: "Avocado",
    chain_id: "634",
    currency: "USDC",
  },
  {
    name: "Previewnet",
    chain_id: "646",
    currency: "FLOW",
  },
  {
    name: "SX Network Testnet",
    chain_id: "647",
    currency: "SX",
  },
  {
    name: "Endurance Smart Chain Mainnet",
    chain_id: "648",
    currency: "ACE",
  },
  {
    name: "Kalichain Testnet",
    chain_id: "653",
    currency: "KALIS",
  },
  {
    name: "Kalichain",
    chain_id: "654",
    currency: "KALIS",
  },
  {
    name: "UltronSmartchain",
    chain_id: "662",
    currency: "ULC",
  },
  {
    name: "Pixie Chain Testnet",
    chain_id: "666",
    currency: "PCTT",
  },
  {
    name: "LAOS Arrakis",
    chain_id: "667",
    currency: "LAOS",
  },
  {
    name: "JuncaChain",
    chain_id: "668",
    currency: "JGC",
  },
  {
    name: "JuncaChain testnet",
    chain_id: "669",
    currency: "JGCT",
  },
  {
    name: "Karura Network",
    chain_id: "686",
    currency: "KAR",
  },
  {
    name: "Redstone",
    chain_id: "690",
    currency: "ETH",
  },
  {
    name: "Star Social Testnet",
    chain_id: "700",
    currency: "SNS",
  },
  {
    name: "Darwinia Koi Testnet",
    chain_id: "701",
    currency: "KRING",
  },
  {
    name: "BlockChain Station Mainnet",
    chain_id: "707",
    currency: "BCS",
  },
  {
    name: "BlockChain Station Testnet",
    chain_id: "708",
    currency: "tBCS",
  },
  {
    name: "Highbury",
    chain_id: "710",
    currency: "FURY",
  },
  {
    name: "Vrcscan Mainnet",
    chain_id: "713",
    currency: "VRC",
  },
  {
    name: "Shibarium Beta",
    chain_id: "719",
    currency: "BONE",
  },
  {
    name: "Lycan Chain",
    chain_id: "721",
    currency: "LYC",
  },
  {
    name: "Blucrates",
    chain_id: "727",
    currency: "BLU",
  },
  {
    name: "Lovely Network Mainnet",
    chain_id: "730",
    currency: "LOVELY",
  },
  {
    name: "Canto Testnet",
    chain_id: "740",
    currency: "CANTO",
  },
  {
    name: "Vention Smart Chain Testnet",
    chain_id: "741",
    currency: "VNT",
  },
  {
    name: "Script Testnet",
    chain_id: "742",
    currency: "SPAY",
  },
  {
    name: "Mainnet",
    chain_id: "747",
    currency: "FLOW",
  },
  {
    name: "QL1",
    chain_id: "766",
    currency: "QOM",
  },
  {
    name: "cheapETH",
    chain_id: "777",
    currency: "cTH",
  },
  {
    name: "MAAL Chain",
    chain_id: "786",
    currency: "MAAL",
  },
  {
    name: "Acala Network",
    chain_id: "787",
    currency: "ACA",
  },
  {
    name: "Aerochain Testnet",
    chain_id: "788",
    currency: "TAero",
  },
  {
    name: "Patex",
    chain_id: "789",
    currency: "ETH",
  },
  {
    name: "Rupaya Testnet",
    chain_id: "799",
    currency: "TRUPX",
  },
  {
    name: "Lucid Blockchain",
    chain_id: "800",
    currency: "LUCID",
  },
  {
    name: "Haic",
    chain_id: "803",
    currency: "HAIC",
  },
  {
    name: "Portal Fantasy Chain Test",
    chain_id: "808",
    currency: "PFT",
  },
  {
    name: "Haven1 Testnet",
    chain_id: "810",
    currency: "H1",
  },
  {
    name: "Qitmeer Network Mainnet",
    chain_id: "813",
    currency: "MEER",
  },
  {
    name: "Firechain zkEVM",
    chain_id: "814",
    currency: "ETH",
  },
  {
    name: "BeOne Chain Mainnet",
    chain_id: "818",
    currency: "BOC",
  },
  {
    name: "Callisto Mainnet",
    chain_id: "820",
    currency: "CLO",
  },
  {
    name: "Runic Chain Testnet",
    chain_id: "822",
    currency: "rBTC",
  },
  {
    name: "CheckDot Blockchain Devnet",
    chain_id: "831",
    currency: "CDT",
  },
  {
    name: "Taraxa Mainnet",
    chain_id: "841",
    currency: "TARA",
  },
  {
    name: "Taraxa Testnet",
    chain_id: "842",
    currency: "TARA",
  },
  {
    name: "HongKong Mainnet",
    chain_id: "852",
    currency: "HK",
  },
  {
    name: "Zeeth Chain Dev",
    chain_id: "859",
    currency: "ZTH",
  },
  {
    name: "Fantasia Chain Mainnet",
    chain_id: "868",
    currency: "FST",
  },
  {
    name: "Bandai Namco Research Verse Mainnet",
    chain_id: "876",
    currency: "OAS",
  },
  {
    name: "Dexit Network",
    chain_id: "877",
    currency: "DXT",
  },
  {
    name: "Ambros Chain Mainnet",
    chain_id: "880",
    currency: "AMBROS",
  },
  {
    name: "Wanchain",
    chain_id: "888",
    currency: "WAN",
  },
  {
    name: "MAXI Chain Testnet",
    chain_id: "898",
    currency: "MGAS",
  },
  {
    name: "MAXI Chain Mainnet",
    chain_id: "899",
    currency: "MGAS",
  },
  {
    name: "Garizon Testnet Stage0",
    chain_id: "900",
    currency: "GAR",
  },
  {
    name: "Garizon Testnet Stage1",
    chain_id: "901",
    currency: "GAR",
  },
  {
    name: "Garizon Testnet Stage2",
    chain_id: "902",
    currency: "GAR",
  },
  {
    name: "Garizon Testnet Stage3",
    chain_id: "903",
    currency: "GAR",
  },
  {
    name: "DecentraBone Layer1 Testnet",
    chain_id: "910",
    currency: "DBONE",
  },
  {
    name: "TAPROOT Mainnet",
    chain_id: "911",
    currency: "TBTC",
  },
  {
    name: "Rinia Testnet",
    chain_id: "917",
    currency: "FIRE",
  },
  {
    name: "Mode Testnet",
    chain_id: "919",
    currency: "ETH",
  },
  {
    name: "Yidark Chain Mainnet",
    chain_id: "927",
    currency: "YDK",
  },
  {
    name: "PulseChain Testnet",
    chain_id: "940",
    currency: "tPLS",
  },
  {
    name: "PulseChain Testnet v2b",
    chain_id: "941",
    currency: "tPLS",
  },
  {
    name: "PulseChain Testnet v3",
    chain_id: "942",
    currency: "tPLS",
  },
  {
    name: "PulseChain Testnet v4",
    chain_id: "943",
    currency: "tPLS",
  },
  {
    name: "Lyra Chain",
    chain_id: "957",
    currency: "ETH",
  },
  {
    name: "BTC20 Smart Chain",
    chain_id: "963",
    currency: "BTCC",
  },
  {
    name: "EthXY",
    chain_id: "969",
    currency: "SEXY",
  },
  {
    name: "Oort Mainnet",
    chain_id: "970",
    currency: "OORT",
  },
  {
    name: "Oort Ascraeus",
    chain_id: "972",
    currency: "CCNA",
  },
  {
    name: "Nepal Blockchain Network",
    chain_id: "977",
    currency: "YETI",
  },
  {
    name: "EthXY Testnet",
    chain_id: "979",
    currency: "SEXY",
  },
  {
    name: "TOP Mainnet EVM",
    chain_id: "980",
    currency: "ETH",
  },
  {
    name: "Memo Smart Chain Mainnet",
    chain_id: "985",
    currency: "CMEMO",
  },
  {
    name: "BinaryChain Mainnet",
    chain_id: "987",
    currency: "BNRY",
  },
  {
    name: "eLiberty Mainnet",
    chain_id: "990",
    currency: "$EL",
  },
  {
    name: "5ireChain Mainnet",
    chain_id: "995",
    currency: "5IRE",
  },
  {
    name: "5ireChain Thunder",
    chain_id: "997",
    currency: "T5IRE",
  },
  {
    name: "Lucky Network",
    chain_id: "998",
    currency: "L99",
  },
  {
    name: "Wanchain Testnet",
    chain_id: "999",
    currency: "WAN",
  },
  {
    name: "GTON Mainnet",
    chain_id: "1000",
    currency: "GCD",
  },
  {
    name: "Klaytn Testnet Baobab",
    chain_id: "1001",
    currency: "KLAY",
  },
  {
    name: "Tectum Emission Token",
    chain_id: "1003",
    currency: "TET",
  },
  {
    name: "T-EKTA",
    chain_id: "1004",
    currency: "T-EKTA",
  },
  {
    name: "Newton Testnet",
    chain_id: "1007",
    currency: "NEW",
  },
  {
    name: "Eurus Mainnet",
    chain_id: "1008",
    currency: "EUN",
  },
  {
    name: "Jumbochain Mainnet",
    chain_id: "1009",
    currency: "JNFTC",
  },
  {
    name: "Evrice Network",
    chain_id: "1010",
    currency: "EVC",
  },
  {
    name: "Rebus Mainnet",
    chain_id: "1011",
    currency: "REBUS",
  },
  {
    name: "Newton",
    chain_id: "1012",
    currency: "NEW",
  },
  {
    name: "CLV Parachain",
    chain_id: "1024",
    currency: "CLV",
  },
  {
    name: "BitTorrent Chain Testnet",
    chain_id: "1028",
    currency: "BTT",
  },
  {
    name: "Conflux eSpace",
    chain_id: "1030",
    currency: "CFX",
  },
  {
    name: "Proxy Network Testnet",
    chain_id: "1031",
    currency: "PRX",
  },
  {
    name: "Bronos Testnet",
    chain_id: "1038",
    currency: "tBRO",
  },
  {
    name: "ShimmerEVM Testnet",
    chain_id: "1073",
    currency: "SMR",
  },
  {
    name: "IOTA EVM Testnet",
    chain_id: "1075",
    currency: "IOTA",
  },
  {
    name: "Mintara Testnet",
    chain_id: "1079",
    currency: "MNTR",
  },
  {
    name: "Mintara Mainnet",
    chain_id: "1080",
    currency: "MNTR",
  },
  {
    name: "Metis Andromeda Mainnet",
    chain_id: "1088",
    currency: "METIS",
  },
  {
    name: "Humans.ai Mainnet",
    chain_id: "1089",
    currency: "HEART",
  },
  {
    name: "Dymension",
    chain_id: "1100",
    currency: "DYM",
  },
  {
    name: "Polygon zkEVM",
    chain_id: "1101",
    currency: "ETH",
  },
  {
    name: "BLXq Testnet",
    chain_id: "1107",
    currency: "BLXQ",
  },
  {
    name: "BLXq Mainnet",
    chain_id: "1108",
    currency: "BLXQ",
  },
  {
    name: "WEMIX3.0 Mainnet",
    chain_id: "1111",
    currency: "WEMIX",
  },
  {
    name: "WEMIX3.0 Testnet",
    chain_id: "1112",
    currency: "tWEMIX",
  },
  {
    name: "B2 Hub Testnet",
    chain_id: "1113",
    currency: "B2",
  },
  {
    name: "Core Blockchain Testnet",
    chain_id: "1115",
    currency: "tCORE",
  },
  {
    name: "Core Blockchain Mainnet",
    chain_id: "1116",
    currency: "CORE",
  },
  {
    name: "Dogcoin Mainnet",
    chain_id: "1117",
    currency: "DOGS",
  },
  {
    name: "B2 Testnet",
    chain_id: "1123",
    currency: "BTC",
  },
  {
    name: "DeFiMetaChain Changi Testnet",
    chain_id: "1133",
    currency: "DFI",
  },
  {
    name: "Lisk",
    chain_id: "1135",
    currency: "ETH",
  },
  {
    name: "AmStar Testnet",
    chain_id: "1138",
    currency: "SINSO",
  },
  {
    name: "MathChain",
    chain_id: "1139",
    currency: "MATH",
  },
  {
    name: "MathChain Testnet",
    chain_id: "1140",
    currency: "MATH",
  },
  {
    name: "Flag Testnet",
    chain_id: "1147",
    currency: "FLAG",
  },
  {
    name: "Symplexia Smart Chain",
    chain_id: "1149",
    currency: "PLEX",
  },
  {
    name: "Origin Testnet",
    chain_id: "1170",
    currency: "UOC",
  },
  {
    name: "Smart Host Teknoloji TESTNET",
    chain_id: "1177",
    currency: "tSHT",
  },
  {
    name: "ClubMos Mainnet",
    chain_id: "1188",
    currency: "MOS",
  },
  {
    name: "Iora Chain",
    chain_id: "1197",
    currency: "IORA",
  },
  {
    name: "Cuckoo Chain",
    chain_id: "1200",
    currency: "CAI",
  },
  {
    name: "Evanesco Testnet",
    chain_id: "1201",
    currency: "AVIS",
  },
  {
    name: "World Trade Technical Chain Mainnet",
    chain_id: "1202",
    currency: "WTT",
  },
  {
    name: "SaitaBlockChain(SBC)",
    chain_id: "1209",
    currency: "STC",
  },
  {
    name: "Cuckoo Sepolia",
    chain_id: "1210",
    currency: "CAI",
  },
  {
    name: "Popcateum Mainnet",
    chain_id: "1213",
    currency: "POP",
  },
  {
    name: "EnterChain Mainnet",
    chain_id: "1214",
    currency: "ENTER",
  },
  {
    name: "Cycle Network Testnet",
    chain_id: "1221",
    currency: "ETH",
  },
  {
    name: "Cycle Network Testnet Jellyfish",
    chain_id: "1223",
    currency: "ETH",
  },
  {
    name: "Hybrid Testnet (Deprecated)",
    chain_id: "1224",
    currency: "HYB",
  },
  {
    name: "Hybrid Testnet",
    chain_id: "1225",
    currency: "HYB",
  },
  {
    name: "Exzo Network Mainnet",
    chain_id: "1229",
    currency: "XZO",
  },
  {
    name: "Ultron Testnet",
    chain_id: "1230",
    currency: "ULX",
  },
  {
    name: "Ultron Mainnet",
    chain_id: "1231",
    currency: "ULX",
  },
  {
    name: "Step Network",
    chain_id: "1234",
    currency: "FITFI",
  },
  {
    name: "ITX Mainnet",
    chain_id: "1235",
    currency: "ITX",
  },
  {
    name: "ARC Mainnet",
    chain_id: "1243",
    currency: "ARC",
  },
  {
    name: "ARC Testnet",
    chain_id: "1244",
    currency: "ARC",
  },
  {
    name: "OM Platform Mainnet",
    chain_id: "1246",
    currency: "OM",
  },
  {
    name: "Dogether Mainnet",
    chain_id: "1248",
    currency: "dogeth",
  },
  {
    name: "CIC Chain Testnet",
    chain_id: "1252",
    currency: "CICT",
  },
  {
    name: "HALO Mainnet",
    chain_id: "1280",
    currency: "HO",
  },
  {
    name: "Moonbeam",
    chain_id: "1284",
    currency: "GLMR",
  },
  {
    name: "Moonriver",
    chain_id: "1285",
    currency: "MOVR",
  },
  {
    name: "Moonbase Alpha",
    chain_id: "1287",
    currency: "DEV",
  },
  {
    name: "Moonrock",
    chain_id: "1288",
    currency: "ROC",
  },
  {
    name: "Swisstronik Testnet",
    chain_id: "1291",
    currency: "SWTR",
  },
  {
    name: "Bobabeam",
    chain_id: "1294",
    currency: "BOBA",
  },
  {
    name: "Bobabase Testnet",
    chain_id: "1297",
    currency: "BOBA",
  },
  {
    name: "Dos Fuji Subnet",
    chain_id: "1311",
    currency: "DOS",
  },
  {
    name: "JaiHo Chain",
    chain_id: "1313",
    currency: "JaiHo",
  },
  {
    name: "Alyx Mainnet",
    chain_id: "1314",
    currency: "ALYX",
  },
  {
    name: "AIA Mainnet",
    chain_id: "1319",
    currency: "AIA",
  },
  {
    name: "AIA Testnet",
    chain_id: "1320",
    currency: "AIA",
  },
  {
    name: "Sei Testnet",
    chain_id: "1328",
    currency: "SEI",
  },
  {
    name: "Sei Network",
    chain_id: "1329",
    currency: "SEI",
  },
  {
    name: "Geth Testnet",
    chain_id: "1337",
    currency: "ETH",
  },
  {
    name: "Elysium Testnet",
    chain_id: "1338",
    currency: "LAVA",
  },
  {
    name: "Elysium Mainnet",
    chain_id: "1339",
    currency: "LAVA",
  },
  {
    name: "Blitz Subnet",
    chain_id: "1343",
    currency: "BGAS",
  },
  {
    name: "CIC Chain Mainnet",
    chain_id: "1353",
    currency: "CIC",
  },
  {
    name: "Zafirium Mainnet",
    chain_id: "1369",
    currency: "ZAFIC",
  },
  {
    name: "Ramestta Mainnet",
    chain_id: "1370",
    currency: "RAMA",
  },
  {
    name: "Pingaksha testnet",
    chain_id: "1377",
    currency: "tRAMA",
  },
  {
    name: "Kalar Chain",
    chain_id: "1379",
    currency: "KLC",
  },
  {
    name: "AmStar Mainnet",
    chain_id: "1388",
    currency: "SINSO",
  },
  {
    name: "Joseon Mainnet",
    chain_id: "1392",
    currency: "JSM",
  },
  {
    name: "Rikeza Network Mainnet",
    chain_id: "1433",
    currency: "RIK",
  },
  {
    name: "Living Assets Mainnet",
    chain_id: "1440",
    currency: "LAS",
  },
  {
    name: "Polygon zkEVM Testnet",
    chain_id: "1442",
    currency: "ETH",
  },
  {
    name: "GIL Testnet",
    chain_id: "1452",
    currency: "GANG",
  },
  {
    name: "MetaChain Istanbul",
    chain_id: "1453",
    currency: "MTC",
  },
  {
    name: "Ctex Scan Blockchain",
    chain_id: "1455",
    currency: "CTEX",
  },
  {
    name: "ZKBase Mainnet",
    chain_id: "1456",
    currency: "ETH",
  },
  {
    name: "Vitruveo Mainnet",
    chain_id: "1490",
    currency: "VTRU",
  },
  {
    name: "iDos Games Chain Testnet",
    chain_id: "1499",
    currency: "IGC",
  },
  {
    name: "BEVM Canary",
    chain_id: "1501",
    currency: "BTC",
  },
  {
    name: "Sherpax Mainnet",
    chain_id: "1506",
    currency: "KSX",
  },
  {
    name: "Sherpax Testnet",
    chain_id: "1507",
    currency: "KSX",
  },
  {
    name: "Beagle Messaging Chain",
    chain_id: "1515",
    currency: "BG",
  },
  {
    name: "Tenet",
    chain_id: "1559",
    currency: "TENET",
  },
  {
    name: "StarCHAIN Testnet",
    chain_id: "1570",
    currency: "STARX",
  },
  {
    name: "StarCHAIN",
    chain_id: "1578",
    currency: "STARX",
  },
  {
    name: "Ethereum Inscription Mainnet",
    chain_id: "1617",
    currency: "ETINS",
  },
  {
    name: "Catecoin Chain Mainnet",
    chain_id: "1618",
    currency: "CATE",
  },
  {
    name: "Atheios",
    chain_id: "1620",
    currency: "ATH",
  },
  {
    name: "Gravity Alpha Mainnet",
    chain_id: "1625",
    currency: "G.",
  },
  {
    name: "Pivotal Mainnet",
    chain_id: "1648",
    currency: "PLUS",
  },
  {
    name: "Btachain",
    chain_id: "1657",
    currency: "BTA",
  },
  {
    name: "Horizen Gobi Testnet",
    chain_id: "1663",
    currency: "tZEN",
  },
  {
    name: "Mint Testnet",
    chain_id: "1686",
    currency: "ETH",
  },
  {
    name: "Mint Sepolia Testnet",
    chain_id: "1687",
    currency: "ETH",
  },
  {
    name: "LUDAN Mainnet",
    chain_id: "1688",
    currency: "LUDAN",
  },
  {
    name: "Anytype EVM Chain",
    chain_id: "1701",
    currency: "ANY",
  },
  {
    name: "TBSI Mainnet",
    chain_id: "1707",
    currency: "JINDA",
  },
  {
    name: "TBSI Testnet",
    chain_id: "1708",
    currency: "JINDA",
  },
  {
    name: "Doric Network",
    chain_id: "1717",
    currency: "DRC",
  },
  {
    name: "Palette Chain Mainnet",
    chain_id: "1718",
    currency: "PLT",
  },
  {
    name: "Reya Network",
    chain_id: "1729",
    currency: "ETH",
  },
  {
    name: "Metal L2 Testnet",
    chain_id: "1740",
    currency: "ETH",
  },
  {
    name: "Metal L2",
    chain_id: "1750",
    currency: "ETH",
  },
  {
    name: "PartyChain",
    chain_id: "1773",
    currency: "GRAMS",
  },
  {
    name: "Gauss Mainnet",
    chain_id: "1777",
    currency: "GANG",
  },
  {
    name: "ZKBase Sepolia Testnet",
    chain_id: "1789",
    currency: "ETH",
  },
  {
    name: "Kerleano",
    chain_id: "1804",
    currency: "CRC",
  },
  {
    name: "Rabbit Analog Testnet Chain",
    chain_id: "1807",
    currency: "rAna",
  },
  {
    name: "Lif3 Chain Testnet",
    chain_id: "1811",
    currency: "LIF3",
  },
  {
    name: "Cube Chain Mainnet",
    chain_id: "1818",
    currency: "CUBE",
  },
  {
    name: "Cube Chain Testnet",
    chain_id: "1819",
    currency: "CUBET",
  },
  {
    name: "Ruby Smart Chain MAINNET",
    chain_id: "1821",
    currency: "RUBY",
  },
  {
    name: "Teslafunds",
    chain_id: "1856",
    currency: "TSF",
  },
  {
    name: "Whitechain",
    chain_id: "1875",
    currency: "WBT",
  },
  {
    name: "Gitshock Cartenz Testnet",
    chain_id: "1881",
    currency: "tGTFX",
  },
  {
    name: "Lightlink Phoenix Mainnet",
    chain_id: "1890",
    currency: "ETH",
  },
  {
    name: "Lightlink Pegasus Testnet",
    chain_id: "1891",
    currency: "ETH",
  },
  {
    name: "BON Network",
    chain_id: "1898",
    currency: "BOY",
  },
  {
    name: "Sports Chain Network",
    chain_id: "1904",
    currency: "SCN",
  },
  {
    name: "Bitcichain Mainnet",
    chain_id: "1907",
    currency: "BITCI",
  },
  {
    name: "Bitcichain Testnet",
    chain_id: "1908",
    currency: "TBITCI",
  },
  {
    name: "Merkle Scan",
    chain_id: "1909",
    currency: "MRK",
  },
  {
    name: "Scalind",
    chain_id: "1911",
    currency: "ETH",
  },
  {
    name: "Ruby Smart Chain Testnet",
    chain_id: "1912",
    currency: "tRUBY",
  },
  {
    name: "UPB CRESCDI Testnet",
    chain_id: "1918",
    currency: "UPBEth",
  },
  {
    name: "ONUS Chain Testnet",
    chain_id: "1945",
    currency: "ONUS",
  },
  {
    name: "D-Chain Mainnet",
    chain_id: "1951",
    currency: "DOINX",
  },
  {
    name: "Selendra Network Testnet",
    chain_id: "1953",
    currency: "tSEL",
  },
  {
    name: "Dexilla Testnet",
    chain_id: "1954",
    currency: "DXZ",
  },
  {
    name: "AIW3 Testnet",
    chain_id: "1956",
    currency: "BTC",
  },
  {
    name: "Selendra Network Mainnet",
    chain_id: "1961",
    currency: "SEL",
  },
  {
    name: "Eleanor",
    chain_id: "1967",
    currency: "MTC",
  },
  {
    name: "Super Smart Chain Testnet",
    chain_id: "1969",
    currency: "TSCS",
  },
  {
    name: "Super Smart Chain Mainnet",
    chain_id: "1970",
    currency: "SCS",
  },
  {
    name: "Atelier",
    chain_id: "1971",
    currency: "ATLR",
  },
  {
    name: "RedeCoin",
    chain_id: "1972",
    currency: "REDEV2",
  },
  {
    name: "ONUS Chain Mainnet",
    chain_id: "1975",
    currency: "ONUS",
  },
  {
    name: "Eurus Testnet",
    chain_id: "1984",
    currency: "EUN",
  },
  {
    name: "SatoshIE",
    chain_id: "1985",
    currency: "TUSHY",
  },
  {
    name: "SatoshIE Testnet",
    chain_id: "1986",
    currency: "TUSHY",
  },
  {
    name: "EtherGem",
    chain_id: "1987",
    currency: "EGEM",
  },
  {
    name: "Hubble Exchange",
    chain_id: "1992",
    currency: "USDC",
  },
  {
    name: "B3 Sepolia Testnet",
    chain_id: "1993",
    currency: "ETH",
  },
  {
    name: "Ekta",
    chain_id: "1994",
    currency: "EKTA",
  },
  {
    name: "edeXa Testnet",
    chain_id: "1995",
    currency: "EDX",
  },
  {
    name: "Sanko",
    chain_id: "1996",
    currency: "DMT",
  },
  {
    name: "Kyoto",
    chain_id: "1997",
    currency: "KYOTO",
  },
  {
    name: "Kyoto Testnet",
    chain_id: "1998",
    currency: "KYOTO",
  },
  {
    name: "Dogechain Mainnet",
    chain_id: "2000",
    currency: "DOGE",
  },
  {
    name: "Milkomeda C1 Mainnet",
    chain_id: "2001",
    currency: "mADA",
  },
  {
    name: "Milkomeda A1 Mainnet",
    chain_id: "2002",
    currency: "mALGO",
  },
  {
    name: "MetaLink Network",
    chain_id: "2004",
    currency: "MTL",
  },
  {
    name: "Panarchy",
    chain_id: "2013",
    currency: "GAS",
  },
  {
    name: "NOW Chain",
    chain_id: "2014",
    currency: "NOW",
  },
  {
    name: "MainnetZ Mainnet",
    chain_id: "2016",
    currency: "NetZ",
  },
  {
    name: "Adiri",
    chain_id: "2017",
    currency: "TEL",
  },
  {
    name: "PublicMint Devnet",
    chain_id: "2018",
    currency: "USD",
  },
  {
    name: "PublicMint Testnet",
    chain_id: "2019",
    currency: "USD",
  },
  {
    name: "PublicMint Mainnet",
    chain_id: "2020",
    currency: "USD",
  },
  {
    name: "Edgeware EdgeEVM Mainnet",
    chain_id: "2021",
    currency: "EDG",
  },
  {
    name: "Beresheet BereEVM Testnet",
    chain_id: "2022",
    currency: "tEDG",
  },
  {
    name: "Taycan Testnet",
    chain_id: "2023",
    currency: "tSFL",
  },
  {
    name: "Swan Saturn Testnet",
    chain_id: "2024",
    currency: "sETH",
  },
  {
    name: "Rangers Protocol Mainnet",
    chain_id: "2025",
    currency: "RPG",
  },
  {
    name: "Edgeless Network",
    chain_id: "2026",
    currency: "EwEth",
  },
  {
    name: "Centrifuge",
    chain_id: "2031",
    currency: "CFG",
  },
  {
    name: "Catalyst",
    chain_id: "2032",
    currency: "NCFG",
  },
  {
    name: "Kiwi Subnet",
    chain_id: "2037",
    currency: "SHRAP",
  },
  {
    name: "Shrapnel Testnet",
    chain_id: "2038",
    currency: "SHRAPG",
  },
  {
    name: "Aleph Zero Testnet",
    chain_id: "2039",
    currency: "TZERO",
  },
  {
    name: "Vanar Mainnet",
    chain_id: "2040",
    currency: "VANRY",
  },
  {
    name: "NeuroWeb",
    chain_id: "2043",
    currency: "NEURO",
  },
  {
    name: "Shrapnel Subnet",
    chain_id: "2044",
    currency: "SHRAPG",
  },
  {
    name: "Stratos Testnet",
    chain_id: "2047",
    currency: "STOS",
  },
  {
    name: "Stratos",
    chain_id: "2048",
    currency: "STOS",
  },
  {
    name: "Movo Smart Chain Mainnet",
    chain_id: "2049",
    currency: "MOVO",
  },
  {
    name: "Quokkacoin Mainnet",
    chain_id: "2077",
    currency: "QKA",
  },
  {
    name: "Altair",
    chain_id: "2088",
    currency: "AIR",
  },
  {
    name: "Algol",
    chain_id: "2089",
    currency: "ALGL",
  },
  {
    name: "Ecoball Mainnet",
    chain_id: "2100",
    currency: "ECO",
  },
  {
    name: "Ecoball Testnet Espuma",
    chain_id: "2101",
    currency: "ECO",
  },
  {
    name: "Exosama Network",
    chain_id: "2109",
    currency: "SAMA",
  },
  {
    name: "UCHAIN Mainnet",
    chain_id: "2112",
    currency: "UCASH",
  },
  {
    name: "Catena Mainnet",
    chain_id: "2121",
    currency: "CMCX",
  },
  {
    name: "Metaplayerone Mainnet",
    chain_id: "2122",
    currency: "METAD",
  },
  {
    name: "Metaplayerone Dubai Testnet",
    chain_id: "2124",
    currency: "MEU",
  },
  {
    name: "BigShortBets Testnet",
    chain_id: "2136",
    currency: "Dolarz",
  },
  {
    name: "BigShortBets",
    chain_id: "2137",
    currency: "USDC",
  },
  {
    name: "Defi Oracle Meta Testnet",
    chain_id: "2138",
    currency: "tETH",
  },
  {
    name: "Oneness Network",
    chain_id: "2140",
    currency: "BTC",
  },
  {
    name: "Oneness TestNet",
    chain_id: "2141",
    currency: "BTC",
  },
  {
    name: "BOSagora Mainnet",
    chain_id: "2151",
    currency: "BOA",
  },
  {
    name: "Findora Mainnet",
    chain_id: "2152",
    currency: "FRA",
  },
  {
    name: "Findora Testnet",
    chain_id: "2153",
    currency: "FRA",
  },
  {
    name: "Findora Forge",
    chain_id: "2154",
    currency: "FRA",
  },
  {
    name: "Animechain Testnet",
    chain_id: "2162",
    currency: "COIN",
  },
  {
    name: "Moonsama Network",
    chain_id: "2199",
    currency: "SAMA",
  },
  {
    name: "Antofy Mainnet",
    chain_id: "2202",
    currency: "ABN",
  },
  {
    name: "Bitcoin EVM",
    chain_id: "2203",
    currency: "BTC",
  },
  {
    name: "Evanesco Mainnet",
    chain_id: "2213",
    currency: "EVA",
  },
  {
    name: "Kava Testnet",
    chain_id: "2221",
    currency: "TKAVA",
  },
  {
    name: "Kava",
    chain_id: "2222",
    currency: "KAVA",
  },
  {
    name: "VChain Mainnet",
    chain_id: "2223",
    currency: "VNDT",
  },
  {
    name: "Krest Network",
    chain_id: "2241",
    currency: "KRST",
  },
  {
    name: "BOMB Chain",
    chain_id: "2300",
    currency: "BOMB",
  },
  {
    name: "Ebro Network",
    chain_id: "2306",
    currency: "ebro",
  },
  {
    name: "Chronicle Vesuvius - Lit Protocol Testnet",
    chain_id: "2311",
    currency: "tstLPX",
  },
  {
    name: "SOMA Network Testnet",
    chain_id: "2323",
    currency: "tSMA",
  },
  {
    name: "Altcoinchain",
    chain_id: "2330",
    currency: "ALT",
  },
  {
    name: "RSS3 VSL Sepolia Testnet",
    chain_id: "2331",
    currency: "RSS3",
  },
  {
    name: "SOMA Network Mainnet",
    chain_id: "2332",
    currency: "SMA",
  },
  {
    name: "Atleta Olympia",
    chain_id: "2340",
    currency: "ATLA",
  },
  {
    name: "Omnia Chain",
    chain_id: "2342",
    currency: "OMNIA",
  },
  {
    name: "(deprecated) Kroma Sepolia",
    chain_id: "2357",
    currency: "ETH",
  },
  {
    name: "Kroma Sepolia",
    chain_id: "2358",
    currency: "ETH",
  },
  {
    name: "Nexis Network Testnet",
    chain_id: "2370",
    currency: "NZT",
  },
  {
    name: "BOMB Chain Testnet",
    chain_id: "2399",
    currency: "tBOMB",
  },
  {
    name: "TCG Verse Mainnet",
    chain_id: "2400",
    currency: "OAS",
  },
  {
    name: "Karak Mainnet",
    chain_id: "2410",
    currency: "ETH",
  },
  {
    name: "XODEX",
    chain_id: "2415",
    currency: "XODEX",
  },
  {
    name: "King Of Legends Mainnet",
    chain_id: "2425",
    currency: "KCC",
  },
  {
    name: "Polygon zkEVM Cardona Testnet",
    chain_id: "2442",
    currency: "ETH",
  },
  {
    name: "Hybrid Chain Network Testnet",
    chain_id: "2458",
    currency: "tHRC",
  },
  {
    name: "Hybrid Chain Network Mainnet",
    chain_id: "2468",
    currency: "HRC",
  },
  {
    name: "Unicorn Ultra Nebulas Testnet",
    chain_id: "2484",
    currency: "U2U",
  },
  {
    name: "Karak Goerli",
    chain_id: "2511",
    currency: "KRK",
  },
  {
    name: "Fraxtal Testnet",
    chain_id: "2522",
    currency: "frxETH",
  },
  {
    name: "inEVM Mainnet",
    chain_id: "2525",
    currency: "INJ",
  },
  {
    name: "Kortho Mainnet",
    chain_id: "2559",
    currency: "KTO",
  },
  {
    name: "TechPay Mainnet",
    chain_id: "2569",
    currency: "TPC",
  },
  {
    name: "PoCRNet",
    chain_id: "2606",
    currency: "CRC",
  },
  {
    name: "Redlight Chain Mainnet",
    chain_id: "2611",
    currency: "REDLC",
  },
  {
    name: "EZChain C-Chain Mainnet",
    chain_id: "2612",
    currency: "EZC",
  },
  {
    name: "EZChain C-Chain Testnet",
    chain_id: "2613",
    currency: "EZC",
  },
  {
    name: "Whitechain Testnet",
    chain_id: "2625",
    currency: "WBT",
  },
  {
    name: "AILayer Testnet",
    chain_id: "2648",
    currency: "BTC",
  },
  {
    name: "AILayer Mainnet",
    chain_id: "2649",
    currency: "BTC",
  },
  {
    name: "Morph Testnet",
    chain_id: "2710",
    currency: "ETH",
  },
  {
    name: "K-LAOS",
    chain_id: "2718",
    currency: "KLAOS",
  },
  {
    name: "XR Sepolia",
    chain_id: "2730",
    currency: "tXR",
  },
  {
    name: "Elizabeth Testnet",
    chain_id: "2731",
    currency: "TIME",
  },
  {
    name: "Nanon",
    chain_id: "2748",
    currency: "ETH",
  },
  {
    name: "GM Network Mainnet",
    chain_id: "2777",
    currency: "ETH",
  },
  {
    name: "Morph Holesky",
    chain_id: "2810",
    currency: "ETH",
  },
  {
    name: "Boba Network Goerli Testnet",
    chain_id: "2888",
    currency: "ETH",
  },
  {
    name: "Elux Chain",
    chain_id: "2907",
    currency: "ELUX",
  },
  {
    name: "HYCHAIN",
    chain_id: "2911",
    currency: "TOPIA",
  },
  {
    name: "Xenon Chain Testnet",
    chain_id: "2941",
    currency: "tXEN",
  },
  {
    name: "BitYuan Mainnet",
    chain_id: "2999",
    currency: "BTY",
  },
  {
    name: "CENNZnet Nikau",
    chain_id: "3001",
    currency: "CPAY",
  },
  {
    name: "Canxium Mainnet",
    chain_id: "3003",
    currency: "CAU",
  },
  {
    name: "PLAYA3ULL GAMES",
    chain_id: "3011",
    currency: "3ULL",
  },
  {
    name: "Orlando Chain",
    chain_id: "3031",
    currency: "ORL",
  },
  {
    name: "Rebus Testnet",
    chain_id: "3033",
    currency: "REBUS",
  },
  {
    name: "Bifrost Mainnet",
    chain_id: "3068",
    currency: "BFC",
  },
  {
    name: "Immu3 EVM",
    chain_id: "3100",
    currency: "IMMU",
  },
  {
    name: "Vulture EVM Beta",
    chain_id: "3102",
    currency: "VFI",
  },
  {
    name: "SatoshiVM Alpha Mainnet",
    chain_id: "3109",
    currency: "BTC",
  },
  {
    name: "SatoshiVM Testnet",
    chain_id: "3110",
    currency: "BTC",
  },
  {
    name: "Dubxcoin network",
    chain_id: "3269",
    currency: "DUBX",
  },
  {
    name: "Dubxcoin testnet",
    chain_id: "3270",
    currency: "TDUBX",
  },
  {
    name: "Debounce Subnet Testnet",
    chain_id: "3306",
    currency: "DB",
  },
  {
    name: "ZCore Testnet",
    chain_id: "3331",
    currency: "ZCR",
  },
  {
    name: "EthStorage Testnet",
    chain_id: "3333",
    currency: "ETH",
  },
  {
    name: "Web3Q Galileo",
    chain_id: "3334",
    currency: "W3Q",
  },
  {
    name: "EthStorage Mainnet",
    chain_id: "3335",
    currency: "ETH",
  },
  {
    name: "The peaq Network",
    chain_id: "3338",
    currency: "PEAQ",
  },
  {
    name: "Paribu Net Mainnet",
    chain_id: "3400",
    currency: "PRB",
  },
  {
    name: "EVOLVE Mainnet",
    chain_id: "3424",
    currency: "EVO",
  },
  {
    name: "SecureChain Testnet",
    chain_id: "3434",
    currency: "SCAI",
  },
  {
    name: "LayerEdge testnet",
    chain_id: "3456",
    currency: "BTC",
  },
  {
    name: "GTCSCAN",
    chain_id: "3490",
    currency: "GTC",
  },
  {
    name: "Paribu Net Testnet",
    chain_id: "3500",
    currency: "PRB",
  },
  {
    name: "JFIN Chain",
    chain_id: "3501",
    currency: "JFIN",
  },
  {
    name: "PandoProject Mainnet",
    chain_id: "3601",
    currency: "PTX",
  },
  {
    name: "PandoProject Testnet",
    chain_id: "3602",
    currency: "PTX",
  },
  {
    name: "Tycooncoin",
    chain_id: "3630",
    currency: "TYCO",
  },
  {
    name: "Botanix Testnet",
    chain_id: "3636",
    currency: "BTC",
  },
  {
    name: "Botanix Mainnet",
    chain_id: "3637",
    currency: "BTC",
  },
  {
    name: "iChain Network",
    chain_id: "3639",
    currency: "ISLAMI",
  },
  {
    name: "iChain Testnet",
    chain_id: "3645",
    currency: "ISLAMI",
  },
  {
    name: "Jouleverse Mainnet",
    chain_id: "3666",
    currency: "J",
  },
  {
    name: "Bittex Mainnet",
    chain_id: "3690",
    currency: "BTX",
  },
  {
    name: "Empire Network",
    chain_id: "3693",
    currency: "EMPIRE",
  },
  {
    name: "SenjePowers Testnet",
    chain_id: "3698",
    currency: "SPC",
  },
  {
    name: "SenjePowers Mainnet",
    chain_id: "3699",
    currency: "SPC",
  },
  {
    name: "Xpla Testnet",
    chain_id: "3701",
    currency: "XPLA",
  },
  {
    name: "Crossbell",
    chain_id: "3737",
    currency: "CSB",
  },
  {
    name: "Astar zkEVM",
    chain_id: "3776",
    currency: "ETH",
  },
  {
    name: "AlveyChain Mainnet",
    chain_id: "3797",
    currency: "ALV",
  },
  {
    name: "Tangle Testnet",
    chain_id: "3799",
    currency: "tTNT",
  },
  {
    name: "Firechain zkEVM Ghostrider",
    chain_id: "3885",
    currency: "ETH",
  },
  {
    name: "KalyChain Mainnet",
    chain_id: "3888",
    currency: "KLC",
  },
  {
    name: "KalyChain Testnet",
    chain_id: "3889",
    currency: "KLC",
  },
  {
    name: "DRAC Network",
    chain_id: "3912",
    currency: "DRAC",
  },
  {
    name: "DOS Tesnet",
    chain_id: "3939",
    currency: "DOS",
  },
  {
    name: "DYNO Mainnet",
    chain_id: "3966",
    currency: "DYNO",
  },
  {
    name: "DYNO Testnet",
    chain_id: "3967",
    currency: "tDYNO",
  },
  {
    name: "APEX Testnet",
    chain_id: "3993",
    currency: "ETH",
  },
  {
    name: "YuanChain Mainnet",
    chain_id: "3999",
    currency: "YCC",
  },
  {
    name: "Ozone Chain Mainnet",
    chain_id: "4000",
    currency: "OZO",
  },
  {
    name: "Peperium Chain Testnet",
    chain_id: "4001",
    currency: "PERIUM",
  },
  {
    name: "Fantom Testnet",
    chain_id: "4002",
    currency: "FTM",
  },
  {
    name: "X1 Fastnet",
    chain_id: "4003",
    currency: "XN",
  },
  {
    name: "Carbonium Testnet Network",
    chain_id: "4040",
    currency: "tCBR",
  },
  {
    name: "GAN Testnet",
    chain_id: "4048",
    currency: "GP",
  },
  {
    name: "Bobaopera Testnet",
    chain_id: "4051",
    currency: "BOBA",
  },
  {
    name: "Bahamut ocean",
    chain_id: "4058",
    currency: "FTN",
  },
  {
    name: "Nahmii 3 Mainnet",
    chain_id: "4061",
    currency: "ETH",
  },
  {
    name: "Nahmii 3 Testnet",
    chain_id: "4062",
    currency: "ETH",
  },
  {
    name: "Muster Mainnet",
    chain_id: "4078",
    currency: "ETH",
  },
  {
    name: "Tobe Chain",
    chain_id: "4080",
    currency: "TBC",
  },
  {
    name: "Fastex Chain (Bahamut) Oasis Testnet",
    chain_id: "4090",
    currency: "FTN",
  },
  {
    name: "Bitindi Testnet",
    chain_id: "4096",
    currency: "$BNI",
  },
  {
    name: "Bitindi Mainnet",
    chain_id: "4099",
    currency: "$BNI",
  },
  {
    name: "AIOZ Network Testnet",
    chain_id: "4102",
    currency: "AIOZ",
  },
  {
    name: "Humans.ai Testnet",
    chain_id: "4139",
    currency: "HEART",
  },
  {
    name: "Tipboxcoin Testnet",
    chain_id: "4141",
    currency: "TPBX",
  },
  {
    name: "CrossFi Testnet",
    chain_id: "4157",
    currency: "XFI",
  },
  {
    name: "PHI Network V1",
    chain_id: "4181",
    currency: "\u03a6",
  },
  {
    name: "Merlin Mainnet",
    chain_id: "4200",
    currency: "BTC",
  },
  {
    name: "LUKSO Testnet",
    chain_id: "4201",
    currency: "LYXt",
  },
  {
    name: "Lisk Sepolia Testnet",
    chain_id: "4202",
    currency: "ETH",
  },
  {
    name: "Nexi Mainnet",
    chain_id: "4242",
    currency: "NEXI",
  },
  {
    name: "Nexi V2 Mainnet",
    chain_id: "4243",
    currency: "NEXI",
  },
  {
    name: "Bobafuji Testnet",
    chain_id: "4328",
    currency: "BOBA",
  },
  {
    name: "Beam",
    chain_id: "4337",
    currency: "BEAM",
  },
  {
    name: "Credit Smart Chain Mainnet",
    chain_id: "4400",
    currency: "CREDIT",
  },
  {
    name: "Htmlcoin Mainnet",
    chain_id: "4444",
    currency: "HTML",
  },
  {
    name: "Orderly Sepolia Testnet",
    chain_id: "4460",
    currency: "ETH",
  },
  {
    name: "Emoney Network Testnet",
    chain_id: "4544",
    currency: "EMYC",
  },
  {
    name: "VERY Mainnet",
    chain_id: "4613",
    currency: "VERY",
  },
  {
    name: "Gold Chain",
    chain_id: "4653",
    currency: "ETH",
  },
  {
    name: "IoTeX Network Mainnet",
    chain_id: "4689",
    currency: "IOTX",
  },
  {
    name: "IoTeX Network Testnet",
    chain_id: "4690",
    currency: "IOTX",
  },
  {
    name: "MEVerse Chain Testnet",
    chain_id: "4759",
    currency: "MEV",
  },
  {
    name: "BlackFort Exchange Network Testnet",
    chain_id: "4777",
    currency: "TBXN",
  },
  {
    name: "Globel Chain",
    chain_id: "4893",
    currency: "GC",
  },
  {
    name: "Venidium Testnet",
    chain_id: "4918",
    currency: "XVM",
  },
  {
    name: "Venidium Mainnet",
    chain_id: "4919",
    currency: "XVM",
  },
  {
    name: "BlackFort Exchange Network",
    chain_id: "4999",
    currency: "BXN",
  },
  {
    name: "Mantle",
    chain_id: "5000",
    currency: "MNT",
  },
  {
    name: "Mantle Testnet",
    chain_id: "5001",
    currency: "MNT",
  },
  {
    name: "Treasurenet Mainnet Alpha",
    chain_id: "5002",
    currency: "UNIT",
  },
  {
    name: "Mantle Sepolia Testnet",
    chain_id: "5003",
    currency: "MNT",
  },
  {
    name: "Treasurenet Testnet",
    chain_id: "5005",
    currency: "UNIT",
  },
  {
    name: "ONIGIRI Test Subnet",
    chain_id: "5039",
    currency: "ONGR",
  },
  {
    name: "ONIGIRI Subnet",
    chain_id: "5040",
    currency: "ONGR",
  },
  {
    name: "Nollie Skatechain Testnet",
    chain_id: "5051",
    currency: "ETH",
  },
  {
    name: "Syndicate Testnet",
    chain_id: "5100",
    currency: "ETH",
  },
  {
    name: "Syndicate Frame Chain",
    chain_id: "5101",
    currency: "ETH",
  },
  {
    name: "SIC Testnet",
    chain_id: "5102",
    currency: "ETH",
  },
  {
    name: "Coordinape Testnet",
    chain_id: "5103",
    currency: "ETH",
  },
  {
    name: "Charmverse Testnet",
    chain_id: "5104",
    currency: "ETH",
  },
  {
    name: "Superloyalty Testnet",
    chain_id: "5105",
    currency: "ETH",
  },
  {
    name: "Azra Testnet",
    chain_id: "5106",
    currency: "ETH",
  },
  {
    name: "Ham",
    chain_id: "5112",
    currency: "ETH",
  },
  {
    name: "Bahamut",
    chain_id: "5165",
    currency: "FTN",
  },
  {
    name: "Smart Layer Network",
    chain_id: "5169",
    currency: "SU",
  },
  {
    name: "TLChain Network Mainnet",
    chain_id: "5177",
    currency: "TLC",
  },
  {
    name: "EraSwap Mainnet",
    chain_id: "5197",
    currency: "ES",
  },
  {
    name: "Humanode Mainnet",
    chain_id: "5234",
    currency: "eHMND",
  },
  {
    name: "Firechain Mainnet Old",
    chain_id: "5290",
    currency: "FIRE",
  },
  {
    name: "Uzmi Network Mainnet",
    chain_id: "5315",
    currency: "UZMI",
  },
  {
    name: "OpTrust Testnet",
    chain_id: "5317",
    currency: "tBNB",
  },
  {
    name: "ITX Testnet",
    chain_id: "5321",
    currency: "ITX",
  },
  {
    name: "Netsbo",
    chain_id: "5333",
    currency: "NETS",
  },
  {
    name: "Tritanium Testnet",
    chain_id: "5353",
    currency: "tTRN",
  },
  {
    name: "Settlus Testnet",
    chain_id: "5372",
    currency: "SETL",
  },
  {
    name: "edeXa Mainnet",
    chain_id: "5424",
    currency: "EDX",
  },
  {
    name: "Egochain",
    chain_id: "5439",
    currency: "EGAX",
  },
  {
    name: "VEX EVM TESTNET",
    chain_id: "5522",
    currency: "VEX",
  },
  {
    name: "Nahmii 2 Mainnet",
    chain_id: "5551",
    currency: "ETH",
  },
  {
    name: "Nahmii 2 Testnet",
    chain_id: "5553",
    currency: "ETH",
  },
  {
    name: "Chain Verse Mainnet",
    chain_id: "5555",
    currency: "OAS",
  },
  {
    name: "opBNB Testnet",
    chain_id: "5611",
    currency: "tBNB",
  },
  {
    name: "Arcturus Testneet",
    chain_id: "5615",
    currency: "tARC",
  },
  {
    name: "Arcturus Chain Testnet",
    chain_id: "5616",
    currency: "tARCT",
  },
  {
    name: "QIE Blockchain",
    chain_id: "5656",
    currency: "QIE",
  },
  {
    name: "Filenova Testnet",
    chain_id: "5675",
    currency: "tFIL",
  },
  {
    name: "Tanssi Demo",
    chain_id: "5678",
    currency: "TANGO",
  },
  {
    name: "Syscoin Tanenbaum Testnet",
    chain_id: "5700",
    currency: "tSYS",
  },
  {
    name: "Hika Network Testnet",
    chain_id: "5729",
    currency: "HIK",
  },
  {
    name: "SatoshiChain Testnet",
    chain_id: "5758",
    currency: "SATS",
  },
  {
    name: "Ganache",
    chain_id: "5777",
    currency: "ETH",
  },
  {
    name: "Tangle",
    chain_id: "5845",
    currency: "TNT",
  },
  {
    name: "Ontology Testnet",
    chain_id: "5851",
    currency: "ONG",
  },
  {
    name: "Wegochain Rubidium Mainnet",
    chain_id: "5869",
    currency: "RBD",
  },
  {
    name: "BounceBit Testnet",
    chain_id: "6000",
    currency: "BB",
  },
  {
    name: "BounceBit Mainnet",
    chain_id: "6001",
    currency: "BB",
  },
  {
    name: "Tres Testnet",
    chain_id: "6065",
    currency: "TRES",
  },
  {
    name: "Tres Mainnet",
    chain_id: "6066",
    currency: "TRES",
  },
  {
    name: "Cascadia Testnet",
    chain_id: "6102",
    currency: "tCC",
  },
  {
    name: "UPTN Testnet",
    chain_id: "6118",
    currency: "UPTN",
  },
  {
    name: "UPTN",
    chain_id: "6119",
    currency: "UPTN",
  },
  {
    name: "LAOS",
    chain_id: "6283",
    currency: "LAOS",
  },
  {
    name: "Aura Euphoria Testnet",
    chain_id: "6321",
    currency: "eAura",
  },
  {
    name: "Aura Mainnet",
    chain_id: "6322",
    currency: "AURA",
  },
  {
    name: "Digit Soul Smart Chain",
    chain_id: "6363",
    currency: "DGC",
  },
  {
    name: "Peerpay",
    chain_id: "6502",
    currency: "P2P",
  },
  {
    name: "Scolcoin WeiChain Testnet",
    chain_id: "6552",
    currency: "SCOL",
  },
  {
    name: "Fox Testnet Network",
    chain_id: "6565",
    currency: "tFOX",
  },
  {
    name: "Pixie Chain Mainnet",
    chain_id: "6626",
    currency: "PIX",
  },
  {
    name: "Latest Chain Testnet",
    chain_id: "6660",
    currency: "LATEST",
  },
  {
    name: "Cybria Mainnet",
    chain_id: "6661",
    currency: "CYBA",
  },
  {
    name: "Cybria Testnet",
    chain_id: "6666",
    currency: "CYBA",
  },
  {
    name: "IRIShub",
    chain_id: "6688",
    currency: "ERIS",
  },
  {
    name: "OX Chain",
    chain_id: "6699",
    currency: "OX",
  },
  {
    name: "PAXB Mainnet",
    chain_id: "6701",
    currency: "PAXB",
  },
  {
    name: "Compverse Mainnet",
    chain_id: "6779",
    currency: "CPV",
  },
  {
    name: "Gold Smart Chain Mainnet",
    chain_id: "6789",
    currency: "STAND",
  },
  {
    name: "RACE Mainnet",
    chain_id: "6805",
    currency: "ETH",
  },
  {
    name: "RACE Testnet",
    chain_id: "6806",
    currency: "ETH",
  },
  {
    name: "Pools Mainnet",
    chain_id: "6868",
    currency: "POOLS",
  },
  {
    name: "Tomb Chain Mainnet",
    chain_id: "6969",
    currency: "TOMB",
  },
  {
    name: "PolySmartChain",
    chain_id: "6999",
    currency: "PSC",
  },
  {
    name: "ZetaChain Mainnet",
    chain_id: "7000",
    currency: "ZETA",
  },
  {
    name: "ZetaChain Testnet",
    chain_id: "7001",
    currency: "ZETA",
  },
  {
    name: "BST Chain",
    chain_id: "7007",
    currency: "BSTC",
  },
  {
    name: "Ella the heart",
    chain_id: "7027",
    currency: "ELLA",
  },
  {
    name: "Planq Mainnet",
    chain_id: "7070",
    currency: "PLQ",
  },
  {
    name: "Planq Atlas Testnet",
    chain_id: "7077",
    currency: "tPLQ",
  },
  {
    name: "Nume",
    chain_id: "7100",
    currency: "DAI",
  },
  {
    name: "Bitrock Mainnet",
    chain_id: "7171",
    currency: "BROCK",
  },
  {
    name: "XPLA Verse",
    chain_id: "7300",
    currency: "OAS",
  },
  {
    name: "KLYNTAR",
    chain_id: "7331",
    currency: "KLY",
  },
  {
    name: "Horizen EON Mainnet",
    chain_id: "7332",
    currency: "ZEN",
  },
  {
    name: "Shyft Mainnet",
    chain_id: "7341",
    currency: "SHYFT",
  },
  {
    name: "Raba Network Mainnet",
    chain_id: "7484",
    currency: "RABA",
  },
  {
    name: "MEVerse Chain Mainnet",
    chain_id: "7518",
    currency: "MEV",
  },
  {
    name: "Cyber Mainnet",
    chain_id: "7560",
    currency: "ETH",
  },
  {
    name: "ADIL Testnet",
    chain_id: "7575",
    currency: "ADIL",
  },
  {
    name: "Adil Chain V2 Mainnet",
    chain_id: "7576",
    currency: "ADIL",
  },
  {
    name: "The Root Network - Mainnet",
    chain_id: "7668",
    currency: "XRP",
  },
  {
    name: "The Root Network - Porcini Testnet",
    chain_id: "7672",
    currency: "XRP",
  },
  {
    name: "Canto",
    chain_id: "7700",
    currency: "CANTO",
  },
  {
    name: "Canto Tesnet",
    chain_id: "7701",
    currency: "CANTO",
  },
  {
    name: "Bitrock Testnet",
    chain_id: "7771",
    currency: "BROCK",
  },
  {
    name: "GDCC MAINNET",
    chain_id: "7774",
    currency: "GDCC",
  },
  {
    name: "GDCC TESTNET",
    chain_id: "7775",
    currency: "GDCC",
  },
  {
    name: "Rise of the Warbots Testnet",
    chain_id: "7777",
    currency: "NMAC",
  },
  {
    name: "Orenium Mainnet Protocol",
    chain_id: "7778",
    currency: "ORE",
  },
  {
    name: "OpenEX LONG Testnet",
    chain_id: "7798",
    currency: "USDT",
  },
  {
    name: "MaalChain Testnet",
    chain_id: "7860",
    currency: "MAAL",
  },
  {
    name: "Hazlor Testnet",
    chain_id: "7878",
    currency: "TSCAS",
  },
  {
    name: "Kinto Mainnet",
    chain_id: "7887",
    currency: "ETH",
  },
  {
    name: "ARDENIUM Athena",
    chain_id: "7895",
    currency: "tARD",
  },
  {
    name: "Dot Blox",
    chain_id: "7923",
    currency: "DTBX",
  },
  {
    name: "MO Mainnet",
    chain_id: "7924",
    currency: "MO",
  },
  {
    name: "DOS Chain",
    chain_id: "7979",
    currency: "DOS",
  },
  {
    name: "Teleport",
    chain_id: "8000",
    currency: "TELE",
  },
  {
    name: "Teleport Testnet",
    chain_id: "8001",
    currency: "TELE",
  },
  {
    name: "MDGL Testnet",
    chain_id: "8029",
    currency: "MDGLT",
  },
  {
    name: "BOAT Mainnet",
    chain_id: "8047",
    currency: "BOAT",
  },
  {
    name: "Karak Sepolia",
    chain_id: "8054",
    currency: "ETH",
  },
  {
    name: "Shardeum Liberty 1.X",
    chain_id: "8080",
    currency: "SHM",
  },
  {
    name: "Shardeum Liberty 2.X",
    chain_id: "8081",
    currency: "SHM",
  },
  {
    name: "Shardeum Sphinx 1.X",
    chain_id: "8082",
    currency: "SHM",
  },
  {
    name: "Bitcoin Chain",
    chain_id: "8086",
    currency: "BTC",
  },
  {
    name: "E-Dollar",
    chain_id: "8087",
    currency: "USD",
  },
  {
    name: "StreamuX Blockchain",
    chain_id: "8098",
    currency: "SmuX",
  },
  {
    name: "Qitmeer Network Testnet",
    chain_id: "8131",
    currency: "MEER-T",
  },
  {
    name: "Testnet BeOne Chain",
    chain_id: "8181",
    currency: "tBOC",
  },
  {
    name: "Torus Mainnet",
    chain_id: "8192",
    currency: "TQF",
  },
  {
    name: "Torus Testnet",
    chain_id: "8194",
    currency: "TTQF",
  },
  {
    name: "Klaytn Mainnet Cypress",
    chain_id: "8217",
    currency: "KLAY",
  },
  {
    name: "Space Subnet",
    chain_id: "8227",
    currency: "FUEL",
  },
  {
    name: "Blockton Blockchain",
    chain_id: "8272",
    currency: "BTON",
  },
  {
    name: "KorthoTest",
    chain_id: "8285",
    currency: "KTO",
  },
  {
    name: "Lorenzo",
    chain_id: "8329",
    currency: "stBTC",
  },
  {
    name: "Dracones Financial Services",
    chain_id: "8387",
    currency: "FUCK",
  },
  {
    name: "Base",
    chain_id: "8453",
    currency: "ETH",
  },
  {
    name: "Chakra Testnet",
    chain_id: "8545",
    currency: "CKR",
  },
  {
    name: "Toki Network",
    chain_id: "8654",
    currency: "TOKI",
  },
  {
    name: "Toki Testnet",
    chain_id: "8655",
    currency: "TOKI",
  },
  {
    name: "Hela Official Runtime Mainnet",
    chain_id: "8668",
    currency: "HLUSD",
  },
  {
    name: "TOOL Global Mainnet",
    chain_id: "8723",
    currency: "OLO",
  },
  {
    name: "TOOL Global Testnet",
    chain_id: "8724",
    currency: "OLO",
  },
  {
    name: "Storagechain Mainnet",
    chain_id: "8726",
    currency: "STOR",
  },
  {
    name: "Storagechain Testnet",
    chain_id: "8727",
    currency: "STOR",
  },
  {
    name: "Alph Network",
    chain_id: "8738",
    currency: "ALPH",
  },
  {
    name: "TMY Chain",
    chain_id: "8768",
    currency: "TMY",
  },
  {
    name: "IOTA EVM",
    chain_id: "8822",
    currency: "IOTA",
  },
  {
    name: "Hydra Chain Testnet",
    chain_id: "8844",
    currency: "tHYDRA",
  },
  {
    name: "MARO Blockchain Mainnet",
    chain_id: "8848",
    currency: "MARO",
  },
  {
    name: "SuperLumio",
    chain_id: "8866",
    currency: "ETH",
  },
  {
    name: "Lif3 Chain",
    chain_id: "8869",
    currency: "LIF3",
  },
  {
    name: "Unique",
    chain_id: "8880",
    currency: "UNQ",
  },
  {
    name: "Quartz by Unique",
    chain_id: "8881",
    currency: "QTZ",
  },
  {
    name: "Opal testnet by Unique",
    chain_id: "8882",
    currency: "UNQ",
  },
  {
    name: "Sapphire by Unique",
    chain_id: "8883",
    currency: "QTZ",
  },
  {
    name: "Avenium Testnet",
    chain_id: "8886",
    currency: "tAVE",
  },
  {
    name: "XANAChain",
    chain_id: "8888",
    currency: "XETA",
  },
  {
    name: "Vyvo Smart Chain",
    chain_id: "8889",
    currency: "VSC",
  },
  {
    name: "Orenium Testnet Protocol",
    chain_id: "8890",
    currency: "tORE",
  },
  {
    name: "Mammoth Mainnet",
    chain_id: "8898",
    currency: "MMT",
  },
  {
    name: "JIBCHAIN L1",
    chain_id: "8899",
    currency: "JBC",
  },
  {
    name: "Algen",
    chain_id: "8911",
    currency: "ALG",
  },
  {
    name: "Algen Testnet",
    chain_id: "8912",
    currency: "ALG",
  },
  {
    name: "Algen Layer2",
    chain_id: "8921",
    currency: "ALG",
  },
  {
    name: "Algen Layer2 Testnet",
    chain_id: "8922",
    currency: "ALG",
  },
  {
    name: "Giant Mammoth Mainnet",
    chain_id: "8989",
    currency: "GMMT",
  },
  {
    name: "bloxberg",
    chain_id: "8995",
    currency: "U+25B3",
  },
  {
    name: "Evmos Testnet",
    chain_id: "9000",
    currency: "tEVMOS",
  },
  {
    name: "Evmos",
    chain_id: "9001",
    currency: "EVMOS",
  },
  {
    name: "Shido Testnet Block",
    chain_id: "9007",
    currency: "SHIDO",
  },
  {
    name: "Shido Mainnet Block",
    chain_id: "9008",
    currency: "SHIDO",
  },
  {
    name: "BerylBit Mainnet",
    chain_id: "9012",
    currency: "BRB",
  },
  {
    name: "Nexa Testnet Block",
    chain_id: "9024",
    currency: "NEXB",
  },
  {
    name: "Nexa Mainnet Block",
    chain_id: "9025",
    currency: "NEXB",
  },
  {
    name: "Genesis Coin",
    chain_id: "9100",
    currency: "GNC",
  },
  {
    name: "Codefin Mainnet",
    chain_id: "9223",
    currency: "COF",
  },
  {
    name: "Dogcoin Testnet",
    chain_id: "9339",
    currency: "DOGS",
  },
  {
    name: "Oasys Testnet",
    chain_id: "9372",
    currency: "OAS",
  },
  {
    name: "Dela Sepolia Testnet",
    chain_id: "9393",
    currency: "ETH",
  },
  {
    name: "Evoke Mainnet",
    chain_id: "9395",
    currency: "MTHN",
  },
  {
    name: "WeaveVM Testnet",
    chain_id: "9496",
    currency: "tWVM",
  },
  {
    name: "Rangers Protocol Testnet Robin",
    chain_id: "9527",
    currency: "tRPG",
  },
  {
    name: "QEasyWeb3 Testnet",
    chain_id: "9528",
    currency: "QET",
  },
  {
    name: "Neonlink Testnet",
    chain_id: "9559",
    currency: "tNEON",
  },
  {
    name: "Oort MainnetDev",
    chain_id: "9700",
    currency: "OORT",
  },
  {
    name: "Boba BNB Testnet",
    chain_id: "9728",
    currency: "BOBA",
  },
  {
    name: "MainnetZ Testnet",
    chain_id: "9768",
    currency: "NetZ",
  },
  {
    name: "PepeNetwork Mainnet",
    chain_id: "9779",
    currency: "WPEPE",
  },
  {
    name: "Tabi Testnet",
    chain_id: "9789",
    currency: "TABI",
  },
  {
    name: "Carbon EVM",
    chain_id: "9790",
    currency: "SWTH",
  },
  {
    name: "Carbon EVM Testnet",
    chain_id: "9792",
    currency: "SWTH",
  },
  {
    name: "OptimusZ7 Mainnet",
    chain_id: "9797",
    currency: "OZ7",
  },
  {
    name: "IMPERIUM TESTNET",
    chain_id: "9818",
    currency: "tIMP",
  },
  {
    name: "IMPERIUM MAINNET",
    chain_id: "9819",
    currency: "IMP",
  },
  {
    name: "BinaryChain Testnet",
    chain_id: "9876",
    currency: "BNRY",
  },
  {
    name: "Dogelayer Mainnet",
    chain_id: "9888",
    currency: "DOGE",
  },
  {
    name: "Larissa Chain",
    chain_id: "9898",
    currency: "LRS",
  },
  {
    name: "Espento Mainnet",
    chain_id: "9911",
    currency: "SPENT",
  },
  {
    name: "Mind Smart Chain Testnet",
    chain_id: "9977",
    currency: "tMIND",
  },
  {
    name: "Combo Mainnet",
    chain_id: "9980",
    currency: "BNB",
  },
  {
    name: "Volley Mainnet",
    chain_id: "9981",
    currency: "V2X",
  },
  {
    name: "Agung Network",
    chain_id: "9990",
    currency: "AGNG",
  },
  {
    name: "Mind Smart Chain Mainnet",
    chain_id: "9996",
    currency: "MIND",
  },
  {
    name: "AltLayer Testnet",
    chain_id: "9997",
    currency: "ETH",
  },
  {
    name: "Ztc Mainnet",
    chain_id: "9998",
    currency: "ZTC",
  },
  {
    name: "myOwn Testnet",
    chain_id: "9999",
    currency: "MYN",
  },
  {
    name: "Smart Bitcoin Cash",
    chain_id: "10000",
    currency: "BCH",
  },
  {
    name: "Smart Bitcoin Cash Testnet",
    chain_id: "10001",
    currency: "BCHT",
  },
  {
    name: "Gon Chain",
    chain_id: "10024",
    currency: "GT",
  },
  {
    name: "Japan Open Chain Testnet",
    chain_id: "10081",
    currency: "JOCT",
  },
  {
    name: "SJATSH",
    chain_id: "10086",
    currency: "ETH",
  },
  {
    name: "MetaNova Verse",
    chain_id: "10096",
    currency: "MNV",
  },
  {
    name: "Blockchain Genesis Mainnet",
    chain_id: "10101",
    currency: "GEN",
  },
  {
    name: "Gnosis Chiado Testnet",
    chain_id: "10200",
    currency: "XDAI",
  },
  {
    name: "MaxxChain Mainnet",
    chain_id: "10201",
    currency: "PWR",
  },
  {
    name: "GLScan",
    chain_id: "10222",
    currency: "GLC",
  },
  {
    name: "Arthera Mainnet",
    chain_id: "10242",
    currency: "AA",
  },
  {
    name: "Arthera Testnet",
    chain_id: "10243",
    currency: "AA",
  },
  {
    name: "0XTade",
    chain_id: "10248",
    currency: "0XT",
  },
  {
    name: "TAO EVM Mainnet",
    chain_id: "10321",
    currency: "TAO",
  },
  {
    name: "TAO EVM Testnet",
    chain_id: "10324",
    currency: "TAO",
  },
  {
    name: "WorldLand Testnet",
    chain_id: "10395",
    currency: "WLC",
  },
  {
    name: "Numbers Mainnet",
    chain_id: "10507",
    currency: "NUM",
  },
  {
    name: "Numbers Testnet",
    chain_id: "10508",
    currency: "NUM",
  },
  {
    name: "CryptoCoinPay",
    chain_id: "10823",
    currency: "CCP",
  },
  {
    name: "Lamina1",
    chain_id: "10849",
    currency: "L1",
  },
  {
    name: "Lamina1 Identity",
    chain_id: "10850",
    currency: "L1ID",
  },
  {
    name: "Quadrans Blockchain",
    chain_id: "10946",
    currency: "QDC",
  },
  {
    name: "Quadrans Blockchain Testnet",
    chain_id: "10947",
    currency: "tQDC",
  },
  {
    name: "Astra",
    chain_id: "11110",
    currency: "ASA",
  },
  {
    name: "WAGMI",
    chain_id: "11111",
    currency: "WGM",
  },
  {
    name: "Astra Testnet",
    chain_id: "11115",
    currency: "tASA",
  },
  {
    name: "HashBit Mainnet",
    chain_id: "11119",
    currency: "HBIT",
  },
  {
    name: "Shine Chain",
    chain_id: "11221",
    currency: "SC20",
  },
  {
    name: "Jiritsu Testnet Subnet",
    chain_id: "11227",
    currency: "TZW",
  },
  {
    name: "Haqq Network",
    chain_id: "11235",
    currency: "ISLM",
  },
  {
    name: "BEVM Mainnet",
    chain_id: "11501",
    currency: "BTC",
  },
  {
    name: "BEVM Testnet",
    chain_id: "11503",
    currency: "BTC",
  },
  {
    name: "SatsChain",
    chain_id: "11521",
    currency: "SATS",
  },
  {
    name: "Sardis Testnet",
    chain_id: "11612",
    currency: "SRDX",
  },
  {
    name: "Artela Testnet",
    chain_id: "11822",
    currency: "ART",
  },
  {
    name: "Santiment Intelligence Network DEPRECATED",
    chain_id: "11888",
    currency: "SANold",
  },
  {
    name: "Polygon Supernet Arianee",
    chain_id: "11891",
    currency: "ARIA20",
  },
  {
    name: "SatoshiChain Mainnet",
    chain_id: "12009",
    currency: "SATS",
  },
  {
    name: "Aternos",
    chain_id: "12020",
    currency: "ATR",
  },
  {
    name: "Singularity ZERO Testnet",
    chain_id: "12051",
    currency: "tZERO",
  },
  {
    name: "Singularity ZERO Mainnet",
    chain_id: "12052",
    currency: "ZERO",
  },
  {
    name: "BRC Chain Mainnet",
    chain_id: "12123",
    currency: "BRC",
  },
  {
    name: "Fibonacci Mainnet",
    chain_id: "12306",
    currency: "FIBO",
  },
  {
    name: "BLG Testnet",
    chain_id: "12321",
    currency: "BLG",
  },
  {
    name: "L3X Protocol",
    chain_id: "12324",
    currency: "ETH",
  },
  {
    name: "L3X Protocol Testnet",
    chain_id: "12325",
    currency: "ETH",
  },
  {
    name: "Step Testnet",
    chain_id: "12345",
    currency: "FITFI",
  },
  {
    name: "RSS3 VSL Mainnet",
    chain_id: "12553",
    currency: "RSS3",
  },
  {
    name: "Rikeza Network Testnet",
    chain_id: "12715",
    currency: "RIK",
  },
  {
    name: "Playdapp Testnet",
    chain_id: "12781",
    currency: "PDA",
  },
  {
    name: "Quantum Chain Testnet",
    chain_id: "12890",
    currency: "tQNET",
  },
  {
    name: "PlayFair Testnet Subnet",
    chain_id: "12898",
    currency: "BTLT",
  },
  {
    name: "SPS",
    chain_id: "13000",
    currency: "ECG",
  },
  {
    name: "Credit Smart Chain",
    chain_id: "13308",
    currency: "CREDIT",
  },
  {
    name: "Beam Testnet",
    chain_id: "13337",
    currency: "BEAM",
  },
  {
    name: "Immutable zkEVM",
    chain_id: "13371",
    currency: "IMX",
  },
  {
    name: "Phoenix Mainnet",
    chain_id: "13381",
    currency: "PHX",
  },
  {
    name: "Masa",
    chain_id: "13396",
    currency: "MASA",
  },
  {
    name: "Immutable zkEVM Testnet",
    chain_id: "13473",
    currency: "tIMX",
  },
  {
    name: "Gravity Alpha Testnet Sepolia",
    chain_id: "13505",
    currency: "G.",
  },
  {
    name: "Kronobit Mainnet",
    chain_id: "13600",
    currency: "KNB",
  },
  {
    name: "Susono",
    chain_id: "13812",
    currency: "OPN",
  },
  {
    name: "SPS Testnet",
    chain_id: "14000",
    currency: "ECG",
  },
  {
    name: "EVOLVE Testnet",
    chain_id: "14324",
    currency: "EVO",
  },
  {
    name: "Vitruveo Testnet",
    chain_id: "14333",
    currency: "tVTRU",
  },
  {
    name: "Vana Satori Testnet",
    chain_id: "14801",
    currency: "DAT",
  },
  {
    name: "Humanode Testnet 5 Israfel",
    chain_id: "14853",
    currency: "eHMND",
  },
  {
    name: "Immutable zkEVM Devnet",
    chain_id: "15003",
    currency: "dIMX",
  },
  {
    name: "Poodl Testnet",
    chain_id: "15257",
    currency: "POODL",
  },
  {
    name: "Poodl Mainnet",
    chain_id: "15259",
    currency: "POODL",
  },
  {
    name: "KYMTC Mainnet",
    chain_id: "15430",
    currency: "KYMTC",
  },
  {
    name: "LoopNetwork Mainnet",
    chain_id: "15551",
    currency: "LOOP",
  },
  {
    name: "Trust EVM Testnet",
    chain_id: "15555",
    currency: "EVM",
  },
  {
    name: "EOS EVM Network Testnet",
    chain_id: "15557",
    currency: "EOS",
  },
  {
    name: "MetaDot Mainnet",
    chain_id: "16000",
    currency: "MTT",
  },
  {
    name: "MetaDot Testnet",
    chain_id: "16001",
    currency: "MTTest",
  },
  {
    name: "DeFiVerse Mainnet",
    chain_id: "16116",
    currency: "OAS",
  },
  {
    name: "PLYR PHI",
    chain_id: "16180",
    currency: "PLYR",
  },
  {
    name: "Incentiv Devnet",
    chain_id: "16350",
    currency: "INC",
  },
  {
    name: "Pivotal Sepolia",
    chain_id: "16481",
    currency: "PLUS",
  },
  {
    name: "Genesys Mainnet",
    chain_id: "16507",
    currency: "GSYS",
  },
  {
    name: "0G-Newton-Testnet",
    chain_id: "16600",
    currency: "A0GI",
  },
  {
    name: "IRIShub Testnet",
    chain_id: "16688",
    currency: "ERIS",
  },
  {
    name: "AirDAO Mainnet",
    chain_id: "16718",
    currency: "AMB",
  },
  {
    name: "IVAR Chain Testnet",
    chain_id: "16888",
    currency: "tIVAR",
  },
  {
    name: "Holesky",
    chain_id: "17000",
    currency: "ETH",
  },
  {
    name: "Redstone Holesky Testnet",
    chain_id: "17001",
    currency: "ETH",
  },
  {
    name: "Garnet Holesky",
    chain_id: "17069",
    currency: "ETH",
  },
  {
    name: "Onchain Points",
    chain_id: "17071",
    currency: "POP",
  },
  {
    name: "DeFiVerse Testnet",
    chain_id: "17117",
    currency: "OAS",
  },
  {
    name: "G8Chain Mainnet",
    chain_id: "17171",
    currency: "G8C",
  },
  {
    name: "Eclipse Subnet",
    chain_id: "17172",
    currency: "ECLP",
  },
  {
    name: "Palette Chain Testnet",
    chain_id: "17180",
    currency: "PLT",
  },
  {
    name: "KONET Mainnet",
    chain_id: "17217",
    currency: "KONET",
  },
  {
    name: "EOS EVM Network",
    chain_id: "17777",
    currency: "EOS",
  },
  {
    name: "Frontier of Dreams Testnet",
    chain_id: "18000",
    currency: "ZKST",
  },
  {
    name: "Smart Trade Networks",
    chain_id: "18122",
    currency: "STN",
  },
  {
    name: "Proof Of Memes",
    chain_id: "18159",
    currency: "POM",
  },
  {
    name: "G8Chain Testnet",
    chain_id: "18181",
    currency: "G8C",
  },
  {
    name: "unreal-old",
    chain_id: "18231",
    currency: "ETH",
  },
  {
    name: "unreal",
    chain_id: "18233",
    currency: "reETH",
  },
  {
    name: "MXC zkEVM Moonchain",
    chain_id: "18686",
    currency: "MXC",
  },
  {
    name: "Titan (TKX)",
    chain_id: "18888",
    currency: "TKX",
  },
  {
    name: "Titan (TKX) Testnet",
    chain_id: "18889",
    currency: "TKX",
  },
  {
    name: "HOME Verse Mainnet",
    chain_id: "19011",
    currency: "OAS",
  },
  {
    name: "BlockX Atlantis Testnet",
    chain_id: "19077",
    currency: "BCX",
  },
  {
    name: "Decentraconnect Social",
    chain_id: "19224",
    currency: "DCSM",
  },
  {
    name: "Magnet Network",
    chain_id: "19527",
    currency: "DOT",
  },
  {
    name: "LBRY Mainnet",
    chain_id: "19600",
    currency: "LBC",
  },
  {
    name: "BTCIX Network",
    chain_id: "19845",
    currency: "BTCIX",
  },
  {
    name: "Camelark Mainnet",
    chain_id: "20001",
    currency: "ETHW",
  },
  {
    name: "Niza Chain Mainnet",
    chain_id: "20041",
    currency: "NIZA",
  },
  {
    name: "Niza Chain Testnet",
    chain_id: "20073",
    currency: "NIZA",
  },
  {
    name: "Callisto Testnet",
    chain_id: "20729",
    currency: "CLO",
  },
  {
    name: "P12 Chain",
    chain_id: "20736",
    currency: "hP2",
  },
  {
    name: "Jono11 Subnet",
    chain_id: "20765",
    currency: "JONO",
  },
  {
    name: "C4EI",
    chain_id: "21004",
    currency: "C4EI",
  },
  {
    name: "All About Healthy",
    chain_id: "21133",
    currency: "AAH",
  },
  {
    name: "DCpay Mainnet",
    chain_id: "21223",
    currency: "DCP",
  },
  {
    name: "DCpay Testnet",
    chain_id: "21224",
    currency: "DCP",
  },
  {
    name: "CENNZnet Azalea",
    chain_id: "21337",
    currency: "CPAY",
  },
  {
    name: "omChain Mainnet",
    chain_id: "21816",
    currency: "OMC",
  },
  {
    name: "BSL Mainnet",
    chain_id: "21912",
    currency: "ONF",
  },
  {
    name: "Taycan",
    chain_id: "22023",
    currency: "SFL",
  },
  {
    name: "AirDAO Testnet",
    chain_id: "22040",
    currency: "AMB",
  },
  {
    name: "Nautilus Mainnet",
    chain_id: "22222",
    currency: "ZBC",
  },
  {
    name: "GoldXChain Testnet",
    chain_id: "22324",
    currency: "GOLDX",
  },
  {
    name: "MAP Protocol",
    chain_id: "22776",
    currency: "MAPO",
  },
  {
    name: "Antofy Testnet",
    chain_id: "23006",
    currency: "ABN",
  },
  {
    name: "Opside Testnet",
    chain_id: "23118",
    currency: "IDE",
  },
  {
    name: "Oasis Sapphire",
    chain_id: "23294",
    currency: "ROSE",
  },
  {
    name: "Oasis Sapphire Testnet",
    chain_id: "23295",
    currency: "TEST",
  },
  {
    name: "DreyerX Mainnet",
    chain_id: "23451",
    currency: "DRX",
  },
  {
    name: "DreyerX Testnet",
    chain_id: "23452",
    currency: "DRX",
  },
  {
    name: "Blast Testnet",
    chain_id: "23888",
    currency: "ETH",
  },
  {
    name: "KYMTC Testnet",
    chain_id: "24076",
    currency: "KYMTC",
  },
  {
    name: "MintMe.com Coin",
    chain_id: "24734",
    currency: "MINTME",
  },
  {
    name: "LiquidLayer Mainnet",
    chain_id: "25186",
    currency: "LILA",
  },
  {
    name: "AlveyChain Testnet",
    chain_id: "25839",
    currency: "tALV",
  },
  {
    name: "Hammer Chain Mainnet",
    chain_id: "25888",
    currency: "GOLDT",
  },
  {
    name: "Bitkub Chain Testnet",
    chain_id: "25925",
    currency: "tKUB",
  },
  {
    name: "Ferrum Testnet",
    chain_id: "26026",
    currency: "tFRM",
  },
  {
    name: "Hertz Network Mainnet",
    chain_id: "26600",
    currency: "HTZ",
  },
  {
    name: "OasisChain Mainnet",
    chain_id: "26863",
    currency: "OAC",
  },
  {
    name: "KLAOS Nova",
    chain_id: "27181",
    currency: "KLAOS",
  },
  {
    name: "Nanon Sepolia",
    chain_id: "27483",
    currency: "ETH",
  },
  {
    name: "zeroone Mainnet Subnet",
    chain_id: "27827",
    currency: "ZERO",
  },
  {
    name: "Vizing Testnet",
    chain_id: "28516",
    currency: "ETH",
  },
  {
    name: "Vizing Mainnet",
    chain_id: "28518",
    currency: "ETH",
  },
  {
    name: "Optimism Bedrock (Goerli Alpha Testnet)",
    chain_id: "28528",
    currency: "ETH",
  },
  {
    name: "Boba Sepolia",
    chain_id: "28882",
    currency: "ETH",
  },
  {
    name: "HYCHAIN Testnet",
    chain_id: "29112",
    currency: "TOPIA",
  },
  {
    name: "KaiChain Testnet",
    chain_id: "29536",
    currency: "KEC",
  },
  {
    name: "MCH Verse Mainnet",
    chain_id: "29548",
    currency: "OAS",
  },
  {
    name: "Piece testnet",
    chain_id: "30067",
    currency: "ECE",
  },
  {
    name: "MiYou Mainnet",
    chain_id: "30088",
    currency: "MY",
  },
  {
    name: "Cerium Testnet",
    chain_id: "30103",
    currency: "CAU",
  },
  {
    name: "Ethersocial Network",
    chain_id: "31102",
    currency: "ESN",
  },
  {
    name: "CloudTx Mainnet",
    chain_id: "31223",
    currency: "CLD",
  },
  {
    name: "CloudTx Testnet",
    chain_id: "31224",
    currency: "CLD",
  },
  {
    name: "GoChain Testnet",
    chain_id: "31337",
    currency: "GO",
  },
  {
    name: "Evoke Testnet",
    chain_id: "31414",
    currency: "MTHN",
  },
  {
    name: "Xchain Mainnet",
    chain_id: "31753",
    currency: "INTD",
  },
  {
    name: "Xchain Testnet",
    chain_id: "31754",
    currency: "INTD",
  },
  {
    name: "W3Gamez Holesky Testnet",
    chain_id: "32001",
    currency: "ETH",
  },
  {
    name: "Santiment Intelligence Network",
    chain_id: "32382",
    currency: "SANR",
  },
  {
    name: "Bitgert Mainnet",
    chain_id: "32520",
    currency: "Brise",
  },
  {
    name: "Fusion Mainnet",
    chain_id: "32659",
    currency: "FSN",
  },
  {
    name: "Zilliqa EVM",
    chain_id: "32769",
    currency: "ZIL",
  },
  {
    name: "Zilliqa EVM Isolated Server",
    chain_id: "32990",
    currency: "ZIL",
  },
  {
    name: "Entangle Mainnet",
    chain_id: "33033",
    currency: "NGL",
  },
  {
    name: "Zilliqa EVM Testnet",
    chain_id: "33101",
    currency: "ZIL",
  },
  {
    name: "Zilliqa 2 EVM proto-testnet",
    chain_id: "33103",
    currency: "ZIL",
  },
  {
    name: "Entangle Testnet",
    chain_id: "33133",
    currency: "NGL",
  },
  {
    name: "Cloudverse Subnet",
    chain_id: "33210",
    currency: "XCLOUD",
  },
  {
    name: "Aves Mainnet",
    chain_id: "33333",
    currency: "AVS",
  },
  {
    name: "Zilliqa EVM Devnet",
    chain_id: "33385",
    currency: "ZIL",
  },
  {
    name: "Zilliqa-2 EVM Devnet",
    chain_id: "33469",
    currency: "ZIL",
  },
  {
    name: "Funki",
    chain_id: "33979",
    currency: "ETH",
  },
  {
    name: "Mode",
    chain_id: "34443",
    currency: "ETH",
  },
  {
    name: "J2O Taro",
    chain_id: "35011",
    currency: "taro",
  },
  {
    name: "Q Mainnet",
    chain_id: "35441",
    currency: "QGOV",
  },
  {
    name: "Q Testnet",
    chain_id: "35443",
    currency: "Q",
  },
  {
    name: "ConnectorManager",
    chain_id: "38400",
    currency: "cmRPG",
  },
  {
    name: "ConnectorManager Robin",
    chain_id: "38401",
    currency: "ttRPG",
  },
  {
    name: "PRM Mainnet",
    chain_id: "39656",
    currency: "PRM",
  },
  {
    name: "Energi Mainnet",
    chain_id: "39797",
    currency: "NRG",
  },
  {
    name: "OHO Mainnet",
    chain_id: "39815",
    currency: "OHO",
  },
  {
    name: "Opulent-X BETA",
    chain_id: "41500",
    currency: "OXYN",
  },
  {
    name: "AgentLayer Testnet",
    chain_id: "42072",
    currency: "AGENT",
  },
  {
    name: "Arbitrum One",
    chain_id: "42161",
    currency: "ETH",
  },
  {
    name: "Arbitrum Nova",
    chain_id: "42170",
    currency: "ETH",
  },
  {
    name: "Celo Mainnet",
    chain_id: "42220",
    currency: "CELO",
  },
  {
    name: "Oasis Emerald Testnet",
    chain_id: "42261",
    currency: "ROSE",
  },
  {
    name: "Oasis Emerald",
    chain_id: "42262",
    currency: "ROSE",
  },
  {
    name: "GoldXChain Mainnet",
    chain_id: "42355",
    currency: "GOLDX",
  },
  {
    name: "ZKFair Mainnet",
    chain_id: "42766",
    currency: "USDC",
  },
  {
    name: "Etherlink Mainnet",
    chain_id: "42793",
    currency: "XTZ",
  },
  {
    name: "Gesoten Verse Testnet",
    chain_id: "42801",
    currency: "OAS",
  },
  {
    name: "Kinto Testnet",
    chain_id: "42888",
    currency: "ETH",
  },
  {
    name: "Athereum",
    chain_id: "43110",
    currency: "ATH",
  },
  {
    name: "Avalanche Fuji Testnet",
    chain_id: "43113",
    currency: "AVAX",
  },
  {
    name: "Avalanche C-Chain",
    chain_id: "43114",
    currency: "AVAX",
  },
  {
    name: "Boba Avax",
    chain_id: "43288",
    currency: "BOBA",
  },
  {
    name: "ZKFair Testnet",
    chain_id: "43851",
    currency: "USDC",
  },
  {
    name: "Frenchain",
    chain_id: "44444",
    currency: "FREN",
  },
  {
    name: "Quantum Network",
    chain_id: "44445",
    currency: "QTM",
  },
  {
    name: "Celo Alfajores Testnet",
    chain_id: "44787",
    currency: "CELO",
  },
  {
    name: "Autobahn Network",
    chain_id: "45000",
    currency: "TXL",
  },
  {
    name: "Swamps L2",
    chain_id: "45454",
    currency: "SWP",
  },
  {
    name: "Deelance Mainnet",
    chain_id: "45510",
    currency: "DEE",
  },
  {
    name: "Fusion Testnet",
    chain_id: "46688",
    currency: "T-FSN",
  },
  {
    name: "REI Network",
    chain_id: "47805",
    currency: "REI",
  },
  {
    name: "Space Subnet Testnet",
    chain_id: "48795",
    currency: "FUEL",
  },
  {
    name: "Zircuit Testnet",
    chain_id: "48899",
    currency: "ETH",
  },
  {
    name: "Wireshape Floripa Testnet",
    chain_id: "49049",
    currency: "WIRE",
  },
  {
    name: "Bifrost Testnet",
    chain_id: "49088",
    currency: "BFC",
  },
  {
    name: "GUNZ Testnet",
    chain_id: "49321",
    currency: "GUN",
  },
  {
    name: "Energi Testnet",
    chain_id: "49797",
    currency: "NRG",
  },
  {
    name: "Liveplex OracleEVM",
    chain_id: "50001",
    currency: "ETH",
  },
  {
    name: "Yooldo Verse Mainnet",
    chain_id: "50005",
    currency: "OAS",
  },
  {
    name: "Yooldo Verse Testnet",
    chain_id: "50006",
    currency: "OAS",
  },
  {
    name: "GTON Testnet",
    chain_id: "50021",
    currency: "GCD",
  },
  {
    name: "Lumoz Testnet Alpha",
    chain_id: "51178",
    currency: "MOZ",
  },
  {
    name: "Sardis Mainnet",
    chain_id: "51712",
    currency: "SRDX",
  },
  {
    name: "Electroneum Mainnet",
    chain_id: "52014",
    currency: "ETN",
  },
  {
    name: "DOID",
    chain_id: "53277",
    currency: "DOID",
  },
  {
    name: "Superseed Sepolia Testnet",
    chain_id: "53302",
    currency: "ETH",
  },
  {
    name: "DODOchain testnet",
    chain_id: "53457",
    currency: "DODO",
  },
  {
    name: "DFK Chain",
    chain_id: "53935",
    currency: "JEWEL",
  },
  {
    name: "Haqq Chain Testnet",
    chain_id: "54211",
    currency: "ISLMT",
  },
  {
    name: "Toronet Testnet",
    chain_id: "54321",
    currency: "TORO",
  },
  {
    name: "Photon Testnet",
    chain_id: "54555",
    currency: "PTON",
  },
  {
    name: "Titan",
    chain_id: "55004",
    currency: "ETH",
  },
  {
    name: "REI Chain Mainnet",
    chain_id: "55555",
    currency: "REI",
  },
  {
    name: "REI Chain Testnet",
    chain_id: "55556",
    currency: "tREI",
  },
  {
    name: "Lambda Chain Mainnet",
    chain_id: "56026",
    currency: "ETH",
  },
  {
    name: "Boba BNB Mainnet",
    chain_id: "56288",
    currency: "BOBA",
  },
  {
    name: "Testnet Zeroone Subnet",
    chain_id: "56400",
    currency: "ZERO",
  },
  {
    name: "VELO Labs Mainnet",
    chain_id: "56789",
    currency: "NOVA",
  },
  {
    name: "DOID Testnet",
    chain_id: "56797",
    currency: "DOID",
  },
  {
    name: "Rollux Testnet",
    chain_id: "57000",
    currency: "TSYS",
  },
  {
    name: "COINSEC Network",
    chain_id: "57451",
    currency: "SEC",
  },
  {
    name: "Sepolia PGN (Public Goods Network)",
    chain_id: "58008",
    currency: "ETH",
  },
  {
    name: "Linea Goerli",
    chain_id: "59140",
    currency: "ETH",
  },
  {
    name: "Linea Sepolia",
    chain_id: "59141",
    currency: "ETH",
  },
  {
    name: "Linea",
    chain_id: "59144",
    currency: "ETH",
  },
  {
    name: "Metis Sepolia Testnet",
    chain_id: "59902",
    currency: "tMETIS",
  },
  {
    name: "Genesys Code Mainnet",
    chain_id: "59971",
    currency: "GCODE",
  },
  {
    name: "Thinkium Testnet Chain 0",
    chain_id: "60000",
    currency: "TKM",
  },
  {
    name: "Thinkium Testnet Chain 1",
    chain_id: "60001",
    currency: "TKM",
  },
  {
    name: "Thinkium Testnet Chain 2",
    chain_id: "60002",
    currency: "TKM",
  },
  {
    name: "Thinkium Testnet Chain 103",
    chain_id: "60103",
    currency: "TKM",
  },
  {
    name: "BOB",
    chain_id: "60808",
    currency: "ETH",
  },
  {
    name: "Orange Chain Mainnet",
    chain_id: "61022",
    currency: "BTC",
  },
  {
    name: "KaiChain",
    chain_id: "61406",
    currency: "KEC",
  },
  {
    name: "AxelChain Dev-Net",
    chain_id: "61800",
    currency: "AIUM",
  },
  {
    name: "Etica Mainnet",
    chain_id: "61803",
    currency: "EGAZ",
  },
  {
    name: "DoKEN Super Chain Mainnet",
    chain_id: "61916",
    currency: "DKN",
  },
  {
    name: "OPTOPIA Testnet",
    chain_id: "62049",
    currency: "ETH",
  },
  {
    name: "Optopia Mainnet",
    chain_id: "62050",
    currency: "ETH",
  },
  {
    name: "Citrea Devnet",
    chain_id: "62298",
    currency: "cBTC",
  },
  {
    name: "Celo Baklava Testnet",
    chain_id: "62320",
    currency: "CELO",
  },
  {
    name: "MultiVAC Mainnet",
    chain_id: "62621",
    currency: "MTV",
  },
  {
    name: "PLYR TAU Testnet",
    chain_id: "62831",
    currency: "PLYR",
  },
  {
    name: "eCredits Mainnet",
    chain_id: "63000",
    currency: "ECS",
  },
  {
    name: "eCredits Testnet",
    chain_id: "63001",
    currency: "ECS",
  },
  {
    name: "Vecno Mainnet",
    chain_id: "65357",
    currency: "VE",
  },
  {
    name: "Scolcoin Mainnet",
    chain_id: "65450",
    currency: "SCOL",
  },
  {
    name: "Janus Testnet",
    chain_id: "66988",
    currency: "JNS",
  },
  {
    name: "SiriusNet",
    chain_id: "67390",
    currency: "MCD",
  },
  {
    name: "Cosmic Chain",
    chain_id: "67588",
    currency: "COSMIC",
  },
  {
    name: "DM2 Verse Mainnet",
    chain_id: "68770",
    currency: "OAS",
  },
  {
    name: "Condrieu",
    chain_id: "69420",
    currency: "CTE",
  },
  {
    name: "Thinkium Mainnet Chain 0",
    chain_id: "70000",
    currency: "TKM",
  },
  {
    name: "Thinkium Mainnet Chain 1",
    chain_id: "70001",
    currency: "TKM",
  },
  {
    name: "Thinkium Mainnet Chain 2",
    chain_id: "70002",
    currency: "TKM",
  },
  {
    name: "Thinkium Mainnet Chain 103",
    chain_id: "70103",
    currency: "TKM",
  },
  {
    name: "Proof of Play - Apex",
    chain_id: "70700",
    currency: "ETH",
  },
  {
    name: "GuapcoinX",
    chain_id: "71111",
    currency: "GuapX",
  },
  {
    name: "Polyjuice Testnet",
    chain_id: "71393",
    currency: "CKB",
  },
  {
    name: "Godwoken Testnet v1",
    chain_id: "71401",
    currency: "pCKB",
  },
  {
    name: "Godwoken Mainnet",
    chain_id: "71402",
    currency: "pCKB",
  },
  {
    name: "CAGA crypto Ankara testnet",
    chain_id: "72778",
    currency: "CAGA",
  },
  {
    name: "Grok Chain Mainnet",
    chain_id: "72992",
    currency: "GROC",
  },
  {
    name: "ICB Testnet",
    chain_id: "73114",
    currency: "ICBT",
  },
  {
    name: "ICB Network",
    chain_id: "73115",
    currency: "ICBX",
  },
  {
    name: "Energy Web Volta Testnet",
    chain_id: "73799",
    currency: "VT",
  },
  {
    name: "Mixin Virtual Machine",
    chain_id: "73927",
    currency: "ETH",
  },
  {
    name: "GEEK Verse Mainnet",
    chain_id: "75512",
    currency: "OAS",
  },
  {
    name: "GEEK Verse Testnet",
    chain_id: "75513",
    currency: "OAS",
  },
  {
    name: "BORAchain mainnet",
    chain_id: "77001",
    currency: "BORA",
  },
  {
    name: "Foundry Chain Testnet",
    chain_id: "77238",
    currency: "tFNC",
  },
  {
    name: "Vention Smart Chain Mainnet",
    chain_id: "77612",
    currency: "VNT",
  },
  {
    name: "Cycle Network Mainnet Sailboat",
    chain_id: "77677",
    currency: "ETH",
  },
  {
    name: "Toronet Mainnet",
    chain_id: "77777",
    currency: "TORO",
  },
  {
    name: "Firenze test network",
    chain_id: "78110",
    currency: "FIN",
  },
  {
    name: "Dragonfly Mainnet (Hexapod)",
    chain_id: "78281",
    currency: "DFLY",
  },
  {
    name: "Amplify Subnet",
    chain_id: "78430",
    currency: "AMP",
  },
  {
    name: "Bulletin Subnet",
    chain_id: "78431",
    currency: "BLT",
  },
  {
    name: "Conduit Subnet",
    chain_id: "78432",
    currency: "CON",
  },
  {
    name: "Vanguard",
    chain_id: "78600",
    currency: "VANRY",
  },
  {
    name: "Gold Smart Chain Testnet",
    chain_id: "79879",
    currency: "STAND",
  },
  {
    name: "Mumbai",
    chain_id: "80001",
    currency: "MATIC",
  },
  {
    name: "Amoy",
    chain_id: "80002",
    currency: "MATIC",
  },
  {
    name: "Berachain bArtio",
    chain_id: "80084",
    currency: "BERA",
  },
  {
    name: "Berachain Artio",
    chain_id: "80085",
    currency: "BERA",
  },
  {
    name: "Hizoco mainnet",
    chain_id: "80096",
    currency: "HZC",
  },
  {
    name: "Nordek Mainnet",
    chain_id: "81041",
    currency: "NRK",
  },
  {
    name: "Blast",
    chain_id: "81457",
    currency: "ETH",
  },
  {
    name: "Quantum Chain Mainnet",
    chain_id: "81720",
    currency: "QNET",
  },
  {
    name: "Smart Layer Network Testnet",
    chain_id: "82459",
    currency: "SU",
  },
  {
    name: "ZEDXION",
    chain_id: "83872",
    currency: "ZEDX",
  },
  {
    name: "Base Goerli Testnet",
    chain_id: "84531",
    currency: "ETH",
  },
  {
    name: "Base Sepolia Testnet",
    chain_id: "84532",
    currency: "ETH",
  },
  {
    name: "Aerie Network",
    chain_id: "84886",
    currency: "AER",
  },
  {
    name: "CYBERTRUST",
    chain_id: "85449",
    currency: "CYBER",
  },
  {
    name: "Nautilus Proteus Testnet",
    chain_id: "88002",
    currency: "tZBC",
  },
  {
    name: "Inoai Network",
    chain_id: "88559",
    currency: "INO",
  },
  {
    name: "Unit Zero Testnet",
    chain_id: "88817",
    currency: "UNIT0",
  },
  {
    name: "Unit Zero Stagenet",
    chain_id: "88819",
    currency: "UNIT0",
  },
  {
    name: "Chiliz Scoville Testnet",
    chain_id: "88880",
    currency: "CHZ",
  },
  {
    name: "Chiliz Spicy Testnet",
    chain_id: "88882",
    currency: "CHZ",
  },
  {
    name: "Chiliz Chain Mainnet",
    chain_id: "88888",
    currency: "CHZ",
  },
  {
    name: "F(x)Core Testnet Network",
    chain_id: "90001",
    currency: "FX",
  },
  {
    name: "Beverly Hills",
    chain_id: "90210",
    currency: "BVE",
  },
  {
    name: "Camp Testnet",
    chain_id: "90354",
    currency: "ETH",
  },
  {
    name: "Nautilus Trition Chain",
    chain_id: "91002",
    currency: "tZBC",
  },
  {
    name: "MetaDAP Enterprise Mainnet",
    chain_id: "91120",
    currency: "DAP",
  },
  {
    name: "Combo Testnet",
    chain_id: "91715",
    currency: "tcBNB",
  },
  {
    name: "Lambda Testnet",
    chain_id: "92001",
    currency: "LAMB",
  },
  {
    name: "LiquidLayer Testnet",
    chain_id: "93572",
    currency: "LILA",
  },
  {
    name: "Mantis Testnet (Hexapod)",
    chain_id: "96970",
    currency: "MANTIS",
  },
  {
    name: "Green Chain Testnet",
    chain_id: "97531",
    currency: "GREEN",
  },
  {
    name: "OptimusZ7 Testnet",
    chain_id: "97970",
    currency: "OZ7",
  },
  {
    name: "Ebi Chain",
    chain_id: "98881",
    currency: "ETH",
  },
  {
    name: "eLiberty Testnet",
    chain_id: "99099",
    currency: "$EL",
  },
  {
    name: "UB Smart Chain(testnet)",
    chain_id: "99998",
    currency: "UBC",
  },
  {
    name: "UB Smart Chain",
    chain_id: "99999",
    currency: "UBC",
  },
  {
    name: "QuarkChain Mainnet Root",
    chain_id: "100000",
    currency: "QKC",
  },
  {
    name: "QuarkChain Mainnet Shard 0",
    chain_id: "100001",
    currency: "QKC",
  },
  {
    name: "QuarkChain Mainnet Shard 1",
    chain_id: "100002",
    currency: "QKC",
  },
  {
    name: "QuarkChain Mainnet Shard 2",
    chain_id: "100003",
    currency: "QKC",
  },
  {
    name: "QuarkChain Mainnet Shard 3",
    chain_id: "100004",
    currency: "QKC",
  },
  {
    name: "QuarkChain Mainnet Shard 4",
    chain_id: "100005",
    currency: "QKC",
  },
  {
    name: "QuarkChain Mainnet Shard 5",
    chain_id: "100006",
    currency: "QKC",
  },
  {
    name: "QuarkChain Mainnet Shard 6",
    chain_id: "100007",
    currency: "QKC",
  },
  {
    name: "QuarkChain Mainnet Shard 7",
    chain_id: "100008",
    currency: "QKC",
  },
  {
    name: "VeChain",
    chain_id: "100009",
    currency: "VET",
  },
  {
    name: "VeChain Testnet",
    chain_id: "100010",
    currency: "VET",
  },
  {
    name: "QuarkChain L2 Mainnet",
    chain_id: "100011",
    currency: "QKC",
  },
  {
    name: "Global Trust Network",
    chain_id: "101010",
    currency: "FREE",
  },
  {
    name: "Creditcoin Testnet",
    chain_id: "102031",
    currency: "tCTC",
  },
  {
    name: "Crystaleum",
    chain_id: "103090",
    currency: "\u25c8",
  },
  {
    name: "Masa Testnet",
    chain_id: "103454",
    currency: "MASA",
  },
  {
    name: "KaspaClassic Mainnet",
    chain_id: "104566",
    currency: "CAS",
  },
  {
    name: "Stratis Mainnet",
    chain_id: "105105",
    currency: "STRAX",
  },
  {
    name: "BROChain Mainnet",
    chain_id: "108801",
    currency: "BRO",
  },
  {
    name: "QuarkChain Devnet Root",
    chain_id: "110000",
    currency: "QKC",
  },
  {
    name: "QuarkChain Devnet Shard 0",
    chain_id: "110001",
    currency: "QKC",
  },
  {
    name: "QuarkChain Devnet Shard 1",
    chain_id: "110002",
    currency: "QKC",
  },
  {
    name: "QuarkChain Devnet Shard 2",
    chain_id: "110003",
    currency: "QKC",
  },
  {
    name: "QuarkChain Devnet Shard 3",
    chain_id: "110004",
    currency: "QKC",
  },
  {
    name: "QuarkChain Devnet Shard 4",
    chain_id: "110005",
    currency: "QKC",
  },
  {
    name: "QuarkChain Devnet Shard 5",
    chain_id: "110006",
    currency: "QKC",
  },
  {
    name: "QuarkChain Devnet Shard 6",
    chain_id: "110007",
    currency: "QKC",
  },
  {
    name: "QuarkChain Devnet Shard 7",
    chain_id: "110008",
    currency: "QKC",
  },
  {
    name: "QuarkChain L2 Testnet",
    chain_id: "110011",
    currency: "QKC",
  },
  {
    name: "MARS Credit",
    chain_id: "110110",
    currency: "MARS",
  },
  {
    name: "Siberium Test Network",
    chain_id: "111000",
    currency: "SIBR",
  },
  {
    name: "Siberium Network",
    chain_id: "111111",
    currency: "SIBR",
  },
  {
    name: "re.al",
    chain_id: "111188",
    currency: "reETH",
  },
  {
    name: "Metachain One Mainnet",
    chain_id: "112358",
    currency: "METAO",
  },
  {
    name: "MetaDAP Enterprise Testnet",
    chain_id: "119139",
    currency: "DAP",
  },
  {
    name: "Gemchain",
    chain_id: "123321",
    currency: "GEM",
  },
  {
    name: "ADIL Devnet",
    chain_id: "123456",
    currency: "ADIL",
  },
  {
    name: "Etherlink Testnet",
    chain_id: "128123",
    currency: "XTZ",
  },
  {
    name: "Odyssey Chain (Testnet)",
    chain_id: "131313",
    currency: "DIONE",
  },
  {
    name: "ETND Chain Mainnets",
    chain_id: "131419",
    currency: "ETND",
  },
  {
    name: "Form Testnet",
    chain_id: "132902",
    currency: "ETH",
  },
  {
    name: "MagApe Testnet",
    chain_id: "141319",
    currency: "MAG",
  },
  {
    name: "ICPlaza Mainnet",
    chain_id: "142857",
    currency: "ict",
  },
  {
    name: "Eclat Mainnet",
    chain_id: "165279",
    currency: "ECLAT",
  },
  {
    name: "Taiko Mainnet",
    chain_id: "167000",
    currency: "ETH",
  },
  {
    name: "Taiko (Alpha-2 Testnet)",
    chain_id: "167004",
    currency: "ETH",
  },
  {
    name: "Taiko Grimsvotn L2",
    chain_id: "167005",
    currency: "ETH",
  },
  {
    name: "Taiko Eldfell L3",
    chain_id: "167006",
    currency: "ETH",
  },
  {
    name: "Taiko Jolnir L2",
    chain_id: "167007",
    currency: "ETH",
  },
  {
    name: "Taiko Katla L2",
    chain_id: "167008",
    currency: "ETH",
  },
  {
    name: "Taiko Hekla L2",
    chain_id: "167009",
    currency: "ETH",
  },
  {
    name: "Chronicle - Lit Protocol Testnet",
    chain_id: "175177",
    currency: "tstLIT",
  },
  {
    name: "Chronicle Yellowstone - Lit Protocol Testnet",
    chain_id: "175188",
    currency: "tstLPX",
  },
  {
    name: "Bitica Chain Mainnet",
    chain_id: "188710",
    currency: "BDCC",
  },
  {
    name: "Condor Test Network",
    chain_id: "188881",
    currency: "CONDOR",
  },
  {
    name: "Mind Network Testnet",
    chain_id: "192940",
    currency: "FHE",
  },
  {
    name: "MAZZE Testnet",
    chain_id: "199991",
    currency: "MAZZE",
  },
  {
    name: "xFair.AI Testnet",
    chain_id: "200000",
    currency: "FAI",
  },
  {
    name: "Milkomeda C1 Testnet",
    chain_id: "200101",
    currency: "mTAda",
  },
  {
    name: "Milkomeda A1 Testnet",
    chain_id: "200202",
    currency: "mTAlgo",
  },
  {
    name: "Akroma",
    chain_id: "200625",
    currency: "AKA",
  },
  {
    name: "Bitlayer Testnet",
    chain_id: "200810",
    currency: "BTC",
  },
  {
    name: "Bitlayer Mainnet",
    chain_id: "200901",
    currency: "BTC",
  },
  {
    name: "Alaya Mainnet",
    chain_id: "201018",
    currency: "atp",
  },
  {
    name: "Alaya Dev Testnet",
    chain_id: "201030",
    currency: "atp",
  },
  {
    name: "Mythical Chain",
    chain_id: "201804",
    currency: "MYTH",
  },
  {
    name: "Decimal Smart Chain Testnet",
    chain_id: "202020",
    currency: "tDEL",
  },
  {
    name: "X1 Devnet",
    chain_id: "202212",
    currency: "XN",
  },
  {
    name: "YMTECH-BESU Testnet",
    chain_id: "202401",
    currency: "ETH",
  },
  {
    name: "Jellie",
    chain_id: "202624",
    currency: "TWL",
  },
  {
    name: "X1 Network",
    chain_id: "204005",
    currency: "XN",
  },
  {
    name: "Auroria Testnet",
    chain_id: "205205",
    currency: "tSTRAX",
  },
  {
    name: "GitAGI Atlas Testnet",
    chain_id: "210049",
    currency: "tGAGI",
  },
  {
    name: "PlatON Mainnet",
    chain_id: "210425",
    currency: "lat",
  },
  {
    name: "Mas Mainnet",
    chain_id: "220315",
    currency: "MAS",
  },
  {
    name: "Reapchain Mainnet",
    chain_id: "221230",
    currency: "REAP",
  },
  {
    name: "Reapchain Testnet",
    chain_id: "221231",
    currency: "tREAP",
  },
  {
    name: "HydraDX",
    chain_id: "222222",
    currency: "WETH",
  },
  {
    name: "DeepL Mainnet",
    chain_id: "222555",
    currency: "DEEPL",
  },
  {
    name: "DeepL Testnet",
    chain_id: "222666",
    currency: "DEEPL",
  },
  {
    name: "Taf ECO Chain Mainnet",
    chain_id: "224168",
    currency: "TAFECO",
  },
  {
    name: "CONET Sebolia Testnet",
    chain_id: "224422",
    currency: "CONET",
  },
  {
    name: "CONET Holesky",
    chain_id: "224433",
    currency: "CONET",
  },
  {
    name: "HashKey Chain Testnet(discard)",
    chain_id: "230315",
    currency: "tHSK",
  },
  {
    name: "Haymo Testnet",
    chain_id: "234666",
    currency: "HYM",
  },
  {
    name: "Orange Chain Testnet",
    chain_id: "240515",
    currency: "BTC",
  },
  {
    name: "ARTIS sigma1",
    chain_id: "246529",
    currency: "ATS",
  },
  {
    name: "ARTIS Testnet tau1",
    chain_id: "246785",
    currency: "tATS",
  },
  {
    name: "Saakuru Testnet",
    chain_id: "247253",
    currency: "OAS",
  },
  {
    name: "CMP-Mainnet",
    chain_id: "256256",
    currency: "CMP",
  },
  {
    name: "Eclat Testnet",
    chain_id: "262371",
    currency: "ECLAT",
  },
  {
    name: "Gear Zero Network Testnet",
    chain_id: "266256",
    currency: "GZN",
  },
  {
    name: "EgonCoin Testnet",
    chain_id: "271271",
    currency: "EGON",
  },
  {
    name: "Social Smart Chain Mainnet",
    chain_id: "281121",
    currency: "$OC",
  },
  {
    name: "Zillion Sepolia Testnet",
    chain_id: "282828",
    currency: "ETH",
  },
  {
    name: "Cipherem Testnet",
    chain_id: "292003",
    currency: "CIP",
  },
  {
    name: "One World Chain Mainnet",
    chain_id: "309075",
    currency: "OWCT",
  },
  {
    name: "SaharaAI Testnet",
    chain_id: "313313",
    currency: "SAH",
  },
  {
    name: "Filecoin - Calibration testnet",
    chain_id: "314159",
    currency: "tFIL",
  },
  {
    name: "Parex Mainnet",
    chain_id: "322202",
    currency: "PRX",
  },
  {
    name: "Bloom Genesis Testnet",
    chain_id: "323213",
    currency: "BGBC",
  },
  {
    name: "WABA Chain Testnet",
    chain_id: "327126",
    currency: "WABA",
  },
  {
    name: "Nal Mainnet",
    chain_id: "328527",
    currency: "ETH",
  },
  {
    name: "TTcoin Smart Chain Mainnet",
    chain_id: "330844",
    currency: "TC",
  },
  {
    name: "Bloom Genesis Mainnet",
    chain_id: "333313",
    currency: "BGBC",
  },
  {
    name: "Aves Testnet",
    chain_id: "333331",
    currency: "AVST",
  },
  {
    name: "Nativ3 Testnet",
    chain_id: "333333",
    currency: "USNT",
  },
  {
    name: "Oone Chain Testnet",
    chain_id: "333666",
    currency: "tOONE",
  },
  {
    name: "Oone Chain Devnet",
    chain_id: "333777",
    currency: "tOONE",
  },
  {
    name: "Polis Testnet",
    chain_id: "333888",
    currency: "tPOLIS",
  },
  {
    name: "Polis Mainnet",
    chain_id: "333999",
    currency: "POLIS",
  },
  {
    name: "UPchain Testnet",
    chain_id: "336655",
    currency: "UBTC",
  },
  {
    name: "UPchain Mainnet",
    chain_id: "336666",
    currency: "UBTC",
  },
  {
    name: "Bitfinity Network Mainnet",
    chain_id: "355110",
    currency: "BFT",
  },
  {
    name: "Bitfinity Network Testnet",
    chain_id: "355113",
    currency: "BFT",
  },
  {
    name: "LAVITA Mainnet",
    chain_id: "360890",
    currency: "vTFUEL",
  },
  {
    name: "Digit Soul Smart Chain 2",
    chain_id: "363636",
    currency: "DGC",
  },
  {
    name: "HAPchain Testnet",
    chain_id: "373737",
    currency: "HAP",
  },
  {
    name: "Metal C-Chain",
    chain_id: "381931",
    currency: "METAL",
  },
  {
    name: "Metal Tahoe C-Chain",
    chain_id: "381932",
    currency: "METAL",
  },
  {
    name: "Tipboxcoin Mainnet",
    chain_id: "404040",
    currency: "TPBX",
  },
  {
    name: "AIE Testnet",
    chain_id: "413413",
    currency: "AIE",
  },
  {
    name: "Kekchain",
    chain_id: "420420",
    currency: "KEK",
  },
  {
    name: "Kekchain (kektest)",
    chain_id: "420666",
    currency: "tKEK",
  },
  {
    name: "Alterium L2 Testnet",
    chain_id: "420692",
    currency: "AltETH",
  },
  {
    name: "Arbitrum Rinkeby",
    chain_id: "421611",
    currency: "ETH",
  },
  {
    name: "Arbitrum Goerli",
    chain_id: "421613",
    currency: "AGOR",
  },
  {
    name: "Arbitrum Sepolia",
    chain_id: "421614",
    currency: "ETH",
  },
  {
    name: "Fastex Chain testnet",
    chain_id: "424242",
    currency: "FTN",
  },
  {
    name: "Markr Go",
    chain_id: "431140",
    currency: "AVAX",
  },
  {
    name: "Dexalot Subnet Testnet",
    chain_id: "432201",
    currency: "ALOT",
  },
  {
    name: "Dexalot Subnet",
    chain_id: "432204",
    currency: "ALOT",
  },
  {
    name: "Syndr L3 Sepolia",
    chain_id: "444444",
    currency: "ETH",
  },
  {
    name: "Weelink Testnet",
    chain_id: "444900",
    currency: "tWLK",
  },
  {
    name: "Patex Sepolia Testnet",
    chain_id: "471100",
    currency: "ETH",
  },
  {
    name: "Ultra Pro Mainnet",
    chain_id: "473861",
    currency: "UPRO",
  },
  {
    name: "OpenChain Mainnet",
    chain_id: "474142",
    currency: "OPC",
  },
  {
    name: "Gobbl Testnet",
    chain_id: "486487",
    currency: "GOBBL",
  },
  {
    name: "Autonomys Testnet Nova Domain",
    chain_id: "490000",
    currency: "TATC",
  },
  {
    name: "Playdapp Network",
    chain_id: "504441",
    currency: "PDA",
  },
  {
    name: "CMP-Testnet",
    chain_id: "512512",
    currency: "CMP",
  },
  {
    name: "DisChain",
    chain_id: "513100",
    currency: "DIS",
  },
  {
    name: "DoCoin Community Chain",
    chain_id: "526916",
    currency: "DCT",
  },
  {
    name: "Scroll Sepolia Testnet",
    chain_id: "534351",
    currency: "ETH",
  },
  {
    name: "Scroll",
    chain_id: "534352",
    currency: "ETH",
  },
  {
    name: "Scroll Alpha Testnet",
    chain_id: "534353",
    currency: "ETH",
  },
  {
    name: "Shinarium Beta",
    chain_id: "534849",
    currency: "SHI",
  },
  {
    name: "BeanEco SmartChain",
    chain_id: "535037",
    currency: "BESC",
  },
  {
    name: "One World Chain Testnet",
    chain_id: "552981",
    currency: "OWCT",
  },
  {
    name: "Pentagon Testnet",
    chain_id: "555555",
    currency: "PEN",
  },
  {
    name: "Eclipse Testnet",
    chain_id: "555666",
    currency: "ECLPS",
  },
  {
    name: "Hypra Mainnet",
    chain_id: "622277",
    currency: "HYP",
  },
  {
    name: "Atlas",
    chain_id: "622463",
    currency: "TON",
  },
  {
    name: "Bear Network Chain Mainnet",
    chain_id: "641230",
    currency: "BRNKC",
  },
  {
    name: "ALL Mainnet",
    chain_id: "651940",
    currency: "ALL",
  },
  {
    name: "Open Campus Codex",
    chain_id: "656476",
    currency: "EDU",
  },
  {
    name: "Xai Mainnet",
    chain_id: "660279",
    currency: "XAI",
  },
  {
    name: "Vision - Vpioneer Test Chain",
    chain_id: "666666",
    currency: "VS",
  },
  {
    name: "Hela Official Runtime Testnet",
    chain_id: "666888",
    currency: "HLUSD",
  },
  {
    name: "Won Network",
    chain_id: "686868",
    currency: "WON",
  },
  {
    name: "Galadriel Devnet",
    chain_id: "696969",
    currency: "GAL",
  },
  {
    name: "Tiltyard Mainnet Subnet",
    chain_id: "710420",
    currency: "TILT",
  },
  {
    name: "Sei Devnet",
    chain_id: "713715",
    currency: "SEI",
  },
  {
    name: "ERAM Mainnet",
    chain_id: "721529",
    currency: "ERAM",
  },
  {
    name: "Hemi Sepolia",
    chain_id: "743111",
    currency: "ETH",
  },
  {
    name: "Bear Network Chain Testnet",
    chain_id: "751230",
    currency: "tBRNKC",
  },
  {
    name: "Miexs Smartchain",
    chain_id: "761412",
    currency: "MIX",
  },
  {
    name: "Lamina1 Testnet",
    chain_id: "764984",
    currency: "L1T",
  },
  {
    name: "Lamina1 Identity Testnet",
    chain_id: "767368",
    currency: "L1IDT",
  },
  {
    name: "Modularium",
    chain_id: "776877",
    currency: "MDM",
  },
  {
    name: "OctaSpace",
    chain_id: "800001",
    currency: "OCTA",
  },
  {
    name: "BIZ Smart Chain Testnet",
    chain_id: "808080",
    currency: "tBIZT",
  },
  {
    name: "zkLink Nova Mainnet",
    chain_id: "810180",
    currency: "ETH",
  },
  {
    name: "zkLink Nova Sepolia Testnet",
    chain_id: "810181",
    currency: "ETH",
  },
  {
    name: "zkLink Nova Goerli Testnet",
    chain_id: "810182",
    currency: "ETH",
  },
  {
    name: "TSC Testnet",
    chain_id: "820522",
    currency: "tTAS",
  },
  {
    name: "CURVE Mainnet",
    chain_id: "827431",
    currency: "CURVE",
  },
  {
    name: "PRM Testnet",
    chain_id: "839320",
    currency: "PRM",
  },
  {
    name: "4GoodNetwork",
    chain_id: "846000",
    currency: "APTA",
  },
  {
    name: "Dodao",
    chain_id: "855456",
    currency: "DODAO",
  },
  {
    name: "BlocX Mainnet",
    chain_id: "879151",
    currency: "BLX",
  },
  {
    name: "REXX Mainnet",
    chain_id: "888882",
    currency: "REXX",
  },
  {
    name: "Vision - Mainnet",
    chain_id: "888888",
    currency: "VS",
  },
  {
    name: "Posichain Mainnet Shard 0",
    chain_id: "900000",
    currency: "POSI",
  },
  {
    name: "Posichain Testnet Shard 0",
    chain_id: "910000",
    currency: "POSI",
  },
  {
    name: "Astria EVM Dusknet",
    chain_id: "912559",
    currency: "RIA",
  },
  {
    name: "Posichain Devnet Shard 0",
    chain_id: "920000",
    currency: "POSI",
  },
  {
    name: "Posichain Devnet Shard 1",
    chain_id: "920001",
    currency: "POSI",
  },
  {
    name: "FNCY Testnet",
    chain_id: "923018",
    currency: "FNCY",
  },
  {
    name: "Jono12 Subnet",
    chain_id: "955081",
    currency: "JONO",
  },
  {
    name: "Eluvio Content Fabric",
    chain_id: "955305",
    currency: "ELV",
  },
  {
    name: "Treasure Ruby",
    chain_id: "978657",
    currency: "MAGIC",
  },
  {
    name: "Forma",
    chain_id: "984122",
    currency: "TIA",
  },
  {
    name: "Forma Sketchpad",
    chain_id: "984123",
    currency: "TIA",
  },
  {
    name: "Ecrox Chain Mainnet",
    chain_id: "988207",
    currency: "ECROX",
  },
  {
    name: "Supernet Testnet",
    chain_id: "998899",
    currency: "CHAIN",
  },
  {
    name: "AmChain",
    chain_id: "999999",
    currency: "AMC",
  },
  {
    name: "Netmind Chain Testnet",
    chain_id: "1100789",
    currency: "NMT",
  },
  {
    name: "Tiltyard Subnet",
    chain_id: "1127469",
    currency: "TILTG",
  },
  {
    name: "Sharecle Mainnet",
    chain_id: "1234567",
    currency: "SHR",
  },
  {
    name: "zKatana",
    chain_id: "1261120",
    currency: "ETH",
  },
  {
    name: "Etho Protocol",
    chain_id: "1313114",
    currency: "ETHO",
  },
  {
    name: "Xerom",
    chain_id: "1313500",
    currency: "XERO",
  },
  {
    name: "Kintsugi",
    chain_id: "1337702",
    currency: "kiETH",
  },
  {
    name: "Kiln",
    chain_id: "1337802",
    currency: "ETH",
  },
  {
    name: "Zhejiang",
    chain_id: "1337803",
    currency: "ETH",
  },
  {
    name: "Automata Testnet",
    chain_id: "1398243",
    currency: "ATA",
  },
  {
    name: "PlayFi Albireo Testnet",
    chain_id: "1612127",
    currency: "ETH",
  },
  {
    name: "Xterio Testnet",
    chain_id: "1637450",
    currency: "tBNB",
  },
  {
    name: "Turkey Demo Dev",
    chain_id: "1731313",
    currency: "ETH",
  },
  {
    name: "DeBank Testnet",
    chain_id: "2021398",
    currency: "USD",
  },
  {
    name: "Plian Mainnet Main",
    chain_id: "2099156",
    currency: "PI",
  },
  {
    name: "PlatON Dev Testnet Deprecated",
    chain_id: "2203181",
    currency: "lat",
  },
  {
    name: "PlatON Dev Testnet2",
    chain_id: "2206132",
    currency: "lat",
  },
  {
    name: "DPU Chain",
    chain_id: "2611555",
    currency: "DGC",
  },
  {
    name: "Xterio Chain",
    chain_id: "2702128",
    currency: "ETH",
  },
  {
    name: "SaharaAI Network",
    chain_id: "3132023",
    currency: "SAH",
  },
  {
    name: "Funki Sepolia Sandbox",
    chain_id: "3397901",
    currency: "ETH",
  },
  {
    name: "Manta Pacific Testnet",
    chain_id: "3441005",
    currency: "MANTA",
  },
  {
    name: "Manta Pacific Sepolia Testnet",
    chain_id: "3441006",
    currency: "ETH",
  },
  {
    name: "AltLayer Zero Gas Network",
    chain_id: "4000003",
    currency: "ZERO",
  },
  {
    name: "Worlds Caldera",
    chain_id: "4281033",
    currency: "ETH",
  },
  {
    name: "Altar Testnet",
    chain_id: "4444444",
    currency: "ETH",
  },
  {
    name: "ZERO Testnet (Sepolia)",
    chain_id: "4457845",
    currency: "ETH",
  },
  {
    name: "NumBlock Chain",
    chain_id: "5112023",
    currency: "NUMB",
  },
  {
    name: "MXC Wannsee zkEVM Testnet",
    chain_id: "5167003",
    currency: "MXC",
  },
  {
    name: "Moonchain Geneva Testnet",
    chain_id: "5167004",
    currency: "MXC",
  },
  {
    name: "Electroneum Testnet",
    chain_id: "5201420",
    currency: "ETN",
  },
  {
    name: "Reactive Kopli",
    chain_id: "5318008",
    currency: "REACT",
  },
  {
    name: "Imversed Mainnet",
    chain_id: "5555555",
    currency: "IMV",
  },
  {
    name: "Imversed Testnet",
    chain_id: "5555558",
    currency: "IMV",
  },
  {
    name: "Astar zKyoto",
    chain_id: "6038361",
    currency: "ETH",
  },
  {
    name: "Safe(AnWang) Mainnet",
    chain_id: "6666665",
    currency: "SAFE",
  },
  {
    name: "Safe(AnWang) Testnet",
    chain_id: "6666666",
    currency: "SAFE",
  },
  {
    name: "Saakuru Mainnet",
    chain_id: "7225878",
    currency: "OAS",
  },
  {
    name: "OpenVessel",
    chain_id: "7355310",
    currency: "VETH",
  },
  {
    name: "QL1 Testnet",
    chain_id: "7668378",
    currency: "QOM",
  },
  {
    name: "Musicoin",
    chain_id: "7762959",
    currency: "MUSIC",
  },
  {
    name: "Zora",
    chain_id: "7777777",
    currency: "ETH",
  },
  {
    name: "Plian Mainnet Subchain 1",
    chain_id: "8007736",
    currency: "PI",
  },
  {
    name: "Fhenix Helium",
    chain_id: "8008135",
    currency: "tFHE",
  },
  {
    name: "Hokum",
    chain_id: "8080808",
    currency: "ETH",
  },
  {
    name: "Waterfall 8 Test Network",
    chain_id: "8601152",
    currency: "WATER",
  },
  {
    name: "HAPchain",
    chain_id: "8794598",
    currency: "HAP",
  },
  {
    name: "XCAP",
    chain_id: "9322252",
    currency: "GAS",
  },
  {
    name: "Milvine",
    chain_id: "9322253",
    currency: "GAS",
  },
  {
    name: "Plian Testnet Subchain 1",
    chain_id: "10067275",
    currency: "TPI",
  },
  {
    name: "Soverun Mainnet",
    chain_id: "10101010",
    currency: "SVRN",
  },
  {
    name: "AlienX Mainnet",
    chain_id: "10241024",
    currency: "ETH",
  },
  {
    name: "ALIENX Hal Testnet",
    chain_id: "10241025",
    currency: "ETH",
  },
  {
    name: "Sepolia",
    chain_id: "11155111",
    currency: "ETH",
  },
  {
    name: "OP Sepolia Testnet",
    chain_id: "11155420",
    currency: "ETH",
  },
  {
    name: "NeoX Testnet T3",
    chain_id: "12227331",
    currency: "GAS",
  },
  {
    name: "NeoX Testnet T4",
    chain_id: "12227332",
    currency: "GAS",
  },
  {
    name: "COTI Devnet",
    chain_id: "13068200",
    currency: "COTI2",
  },
  {
    name: "PepChain Churchill",
    chain_id: "13371337",
    currency: "TPEP",
  },
  {
    name: "Anduschain Mainnet",
    chain_id: "14288640",
    currency: "DEB",
  },
  {
    name: "Plian Testnet Main",
    chain_id: "16658437",
    currency: "TPI",
  },
  {
    name: "Lambda Chain Testnet",
    chain_id: "17000920",
    currency: "ETH",
  },
  {
    name: "Mande Network Mainnet",
    chain_id: "18071918",
    currency: "MAND",
  },
  {
    name: "IOLite",
    chain_id: "18289463",
    currency: "ILT",
  },
  {
    name: "DeepBrainChain Testnet",
    chain_id: "19850818",
    currency: "DBC",
  },
  {
    name: "DeepBrainChain Mainnet",
    chain_id: "19880818",
    currency: "DBC",
  },
  {
    name: "Stability Testnet",
    chain_id: "20180427",
    currency: "FREE",
  },
  {
    name: "SmartMesh Mainnet",
    chain_id: "20180430",
    currency: "SMT",
  },
  {
    name: "quarkblockchain",
    chain_id: "20181205",
    currency: "QKI",
  },
  {
    name: "Pego Network",
    chain_id: "20201022",
    currency: "PG",
  },
  {
    name: "Vcity Testnet",
    chain_id: "20230825",
    currency: "VCITY",
  },
  {
    name: "DeBank Sepolia Testnet",
    chain_id: "20240324",
    currency: "USD",
  },
  {
    name: "DBK Chain",
    chain_id: "20240603",
    currency: "ETH",
  },
  {
    name: "Swan Proxima Testnet",
    chain_id: "20241133",
    currency: "sETH",
  },
  {
    name: "Hokum Testnet",
    chain_id: "20482050",
    currency: "ETH",
  },
  {
    name: "Excelon Mainnet",
    chain_id: "22052002",
    currency: "xlon",
  },
  {
    name: "Excoincial Chain Volta-Testnet",
    chain_id: "27082017",
    currency: "TEXL",
  },
  {
    name: "Excoincial Chain Mainnet",
    chain_id: "27082022",
    currency: "EXL",
  },
  {
    name: "Ancient8 Testnet",
    chain_id: "28122024",
    currency: "ETH",
  },
  {
    name: "Auxilium Network Mainnet",
    chain_id: "28945486",
    currency: "AUX",
  },
  {
    name: "Flachain Mainnet",
    chain_id: "29032022",
    currency: "FLA",
  },
  {
    name: "Joys Digital Mainnet",
    chain_id: "35855456",
    currency: "JOYS",
  },
  {
    name: "SKALE Nebula Hub Testnet",
    chain_id: "37084624",
    currency: "sFUEL",
  },
  {
    name: "Kingdom Chain",
    chain_id: "39916801",
    currency: "KOZI",
  },
  {
    name: "maistestsubnet",
    chain_id: "43214913",
    currency: "MAI",
  },
  {
    name: "Aquachain",
    chain_id: "61717561",
    currency: "AQUA",
  },
  {
    name: "Autonity Bakerloo (Yamuna) Testnet",
    chain_id: "65010003",
    currency: "ATN",
  },
  {
    name: "Autonity Piccadilly (Yamuna) Testnet",
    chain_id: "65100003",
    currency: "ATN",
  },
  {
    name: "Frame Testnet",
    chain_id: "68840142",
    currency: "ETH",
  },
  {
    name: "0xHash Testnet",
    chain_id: "77787778",
    currency: "HETH",
  },
  {
    name: "Backstop Testnet",
    chain_id: "88558801",
    currency: "ZBS",
  },
  {
    name: "T.E.A.M Blockchain",
    chain_id: "88888888",
    currency: "$TEAM",
  },
  {
    name: "Polygon Blackberry",
    chain_id: "94204209",
    currency: "ETH",
  },
  {
    name: "Joys Digital TestNet",
    chain_id: "99415706",
    currency: "TOYS",
  },
  {
    name: "Oraichain Mainnet",
    chain_id: "108160679",
    currency: "ORAI",
  },
  {
    name: "Cyber Testnet",
    chain_id: "111557560",
    currency: "ETH",
  },
  {
    name: "OP Celestia Raspberry",
    chain_id: "123420111",
    currency: "ETH",
  },
  {
    name: "Plume Testnet",
    chain_id: "161221135",
    currency: "ETH",
  },
  {
    name: "Blast Sepolia Testnet",
    chain_id: "168587773",
    currency: "ETH",
  },
  {
    name: "Gather Mainnet Network",
    chain_id: "192837465",
    currency: "GTH",
  },
  {
    name: "Kanazawa",
    chain_id: "222000222",
    currency: "gMELD",
  },
  {
    name: "Neon EVM Devnet",
    chain_id: "245022926",
    currency: "NEON",
  },
  {
    name: "Neon EVM Devnet Rollup",
    chain_id: "245022929",
    currency: "NEON",
  },
  {
    name: "Neon EVM Mainnet",
    chain_id: "245022934",
    currency: "NEON",
  },
  {
    name: "Neon EVM TestNet",
    chain_id: "245022940",
    currency: "NEON",
  },
  {
    name: "Razor Skale Chain",
    chain_id: "278611351",
    currency: "SFUEL",
  },
  {
    name: "OneLedger Mainnet",
    chain_id: "311752642",
    currency: "OLT",
  },
  {
    name: "Nal Sepolia Testnet",
    chain_id: "328527624",
    currency: "ETH",
  },
  {
    name: "Meld",
    chain_id: "333000333",
    currency: "gMELD",
  },
  {
    name: "Deprecated SKALE Calypso Hub Testnet",
    chain_id: "344106930",
    currency: "sFUEL",
  },
  {
    name: "Gather Testnet Network",
    chain_id: "356256156",
    currency: "GTH",
  },
  {
    name: "Deprecated SKALE Europa Hub Testnet",
    chain_id: "476158412",
    currency: "sFUEL",
  },
  {
    name: "Gather Devnet Network",
    chain_id: "486217935",
    currency: "GTH",
  },
  {
    name: "Deprecated SKALE Nebula Hub Testnet",
    chain_id: "503129905",
    currency: "sFUEL",
  },
  {
    name: "Degen Chain",
    chain_id: "666666666",
    currency: "DEGEN",
  },
  {
    name: "Ancient8",
    chain_id: "888888888",
    currency: "ETH",
  },
  {
    name: "PTCESCAN Testnet",
    chain_id: "889910245",
    currency: "PTCE",
  },
  {
    name: "PTCESCAN Mainnet",
    chain_id: "889910246",
    currency: "PTCE",
  },
  {
    name: "SKALE Calypso Hub Testnet",
    chain_id: "974399131",
    currency: "sFUEL",
  },
  {
    name: "Zora Sepolia Testnet",
    chain_id: "999999999",
    currency: "ETH",
  },
  {
    name: "SKALE Titan Hub Testnet",
    chain_id: "1020352220",
    currency: "sFUEL",
  },
  {
    name: "IPOS Network",
    chain_id: "1122334455",
    currency: "IPOS",
  },
  {
    name: "CyberdeckNet",
    chain_id: "1146703430",
    currency: "CYB",
  },
  {
    name: "HUMAN Protocol",
    chain_id: "1273227453",
    currency: "sFUEL",
  },
  {
    name: "Aurora Mainnet",
    chain_id: "1313161554",
    currency: "ETH",
  },
  {
    name: "Aurora Testnet",
    chain_id: "1313161555",
    currency: "ETH",
  },
  {
    name: "PowerGold",
    chain_id: "1313161560",
    currency: "ETH",
  },
  {
    name: "SKALE Titan Hub",
    chain_id: "1350216234",
    currency: "sFUEL",
  },
  {
    name: "Chaos (SKALE Testnet)",
    chain_id: "1351057110",
    currency: "sFUEL",
  },
  {
    name: "RARI Chain Mainnet",
    chain_id: "1380012617",
    currency: "ETH",
  },
  {
    name: "RaptorChain",
    chain_id: "1380996178",
    currency: "RPTR",
  },
  {
    name: "SKALE Europa Hub Testnet",
    chain_id: "1444673419",
    currency: "sFUEL",
  },
  {
    name: "SKALE Nebula Hub",
    chain_id: "1482601649",
    currency: "sFUEL",
  },
  {
    name: "Deprecated SKALE Titan Hub Testnet",
    chain_id: "1517929550",
    currency: "sFUEL",
  },
  {
    name: "SKALE Calypso Hub",
    chain_id: "1564830818",
    currency: "sFUEL",
  },
  {
    name: "Harmony Mainnet Shard 0",
    chain_id: "1666600000",
    currency: "ONE",
  },
  {
    name: "Harmony Mainnet Shard 1",
    chain_id: "1666600001",
    currency: "ONE",
  },
  {
    name: "Harmony Mainnet Shard 2",
    chain_id: "1666600002",
    currency: "ONE",
  },
  {
    name: "Harmony Mainnet Shard 3",
    chain_id: "1666600003",
    currency: "ONE",
  },
  {
    name: "Harmony Testnet Shard 0",
    chain_id: "1666700000",
    currency: "ONE",
  },
  {
    name: "Harmony Testnet Shard 1",
    chain_id: "1666700001",
    currency: "ONE",
  },
  {
    name: "Harmony Devnet Shard 0",
    chain_id: "1666900000",
    currency: "ONE",
  },
  {
    name: "Harmony Devnet Shard 1",
    chain_id: "1666900001",
    currency: "ONE",
  },
  {
    name: "Kakarot Sepolia",
    chain_id: "1802203764",
    currency: "ETH",
  },
  {
    name: "Gemuchain Testnet",
    chain_id: "1903648807",
    currency: "GEMU",
  },
  {
    name: "RARI Chain Testnet",
    chain_id: "1918988905",
    currency: "ETH",
  },
  {
    name: "DataHopper",
    chain_id: "2021121117",
    currency: "HOP",
  },
  {
    name: "SKALE Europa Hub",
    chain_id: "2046399126",
    currency: "sFUEL",
  },
  {
    name: "Ancient8 Testnet (deprecated)",
    chain_id: "2863311531",
    currency: "ETH",
  },
  {
    name: "Pirl",
    chain_id: "3125659152",
    currency: "PIRL",
  },
  {
    name: "OneLedger Testnet Frankenstein",
    chain_id: "4216137055",
    currency: "OLT",
  },
  {
    name: "Palm Testnet",
    chain_id: "11297108099",
    currency: "PALM",
  },
  {
    name: "Palm",
    chain_id: "11297108109",
    currency: "PALM",
  },
  {
    name: "GitSwarm Test Network",
    chain_id: "28872323069",
    currency: "GS-ETH",
  },
  {
    name: "Xai Testnet v2",
    chain_id: "37714555429",
    currency: "sXAI",
  },
  {
    name: "Arbitrum Blueberry",
    chain_id: "88153591557",
    currency: "CGT",
  },
  {
    name: "Alphabet Mainnet",
    chain_id: "111222333444",
    currency: "ALT",
  },
  {
    name: "Ntity Mainnet",
    chain_id: "197710212030",
    currency: "NTT",
  },
  {
    name: "Haradev Testnet",
    chain_id: "197710212031",
    currency: "NTTH",
  },
  {
    name: "GM Network Testnet",
    chain_id: "202402181627",
    currency: "ETH",
  },
  {
    name: "Zeniq",
    chain_id: "383414847825",
    currency: "ZENIQ",
  },
  {
    name: "PDC Mainnet",
    chain_id: "666301171999",
    currency: "PDC",
  },
  {
    name: "Molereum Network",
    chain_id: "6022140761023",
    currency: "MOLE",
  },
  {
    name: "Godwoken Testnet (V1)",
    chain_id: "868455272153094",
    currency: "CKB",
  },
  {
    name: "DCHAIN Testnet",
    chain_id: "2713017997578000",
    currency: "ETH",
  },
  {
    name: "DCHAIN",
    chain_id: "2716446429837000",
    currency: "ETH",
  },
];
